import * as React from "react";

const IconLogo = (className) =>
    <svg width={46} height={46} viewBox="0 0 46 46" fill="none" className={className}>
      <path
        d="M45.058 21.473H31.3v1.804c0 4.777-3.871 8.655-8.648 8.655-4.776 0-8.654-3.878-8.654-8.655 0-4.776 3.877-8.647 8.654-8.647 1.578 0 3.05.424 4.324 1.16a18.245 18.245 0 00-12.858-5.272c-4.862 0-9.278 1.89-12.561 4.982A22.345 22.345 0 00.17 23.277c0 11.953 9.327 21.725 21.102 22.44.418.021.842.043 1.267.043.042 0 .078.007.113.007 12.42 0 22.482-10.07 22.482-22.49.008-.608-.028-1.21-.077-1.804z"
        fill="#D7202C"
      />
      <path
        d="M26.977 15.79l2.285-3.963 4.636-8.025A22.402 22.402 0 0022.653.795c-8.64 0-16.128 4.883-19.892 12.03-.085.163-.184.326-.262.488a21.538 21.538 0 00-.941 2.194 18.213 18.213 0 0112.56-4.989c5.01 0 9.554 2.01 12.859 5.272z"
        fill="#003591"
      />
      <path
        d="M8.38 15.924h.014c1.529.361 2.442 1.826 2.06 3.404-.255 1.069-.864 1.649-1.621 1.96l-.58-1.295c.446-.212.764-.495.884-.998.177-.729-.325-1.394-1.082-1.578H8.04c-.778-.19-1.521.177-1.69.913-.135.545.049.927.353 1.33l-1.047.906c-.56-.65-.906-1.436-.623-2.597.354-1.493 1.783-2.42 3.347-2.045zM9.561 22.838l.298 2.526c.099.814-.05 1.408-.368 1.805-.27.346-.659.559-1.19.622h-.013c-.814.1-1.409-.276-1.77-.905l-1.705 1.493-.205-1.706 1.486-1.266v-.015l-.078-.636-1.614.19-.176-1.478 5.335-.63zm-2.271 2.76c.056.502.34.764.729.722h.014c.417-.05.594-.383.538-.878l-.114-.97-1.28.156.113.97zM8.104 29.766l.014-.007c1.274-.878 3.007-.559 3.949.807.94 1.373.622 3.078-.651 3.956l-.015.007c-1.273.877-3.007.559-3.948-.807-.942-1.373-.623-3.085.65-3.956zm2.42 3.517l.014-.007c.637-.439.878-1.288.41-1.96-.46-.672-1.316-.743-1.953-.304l-.014.007c-.644.438-.877 1.288-.417 1.953.467.672 1.323.75 1.96.311zM11.897 37.346l1.21-.453c.255.63.658 1.11 1.196 1.422.347.198.601.177.715-.021l.007-.014c.113-.191.021-.39-.538-.892-.863-.793-1.479-1.507-.927-2.47l.007-.014c.495-.87 1.536-1.104 2.66-.467.8.453 1.296 1.02 1.572 1.713l-1.168.552c-.255-.545-.63-.97-1.047-1.203-.311-.177-.545-.135-.637.035l-.007.014c-.12.212-.014.396.552.913.941.842 1.415 1.571.92 2.449l-.007.014c-.538.955-1.62 1.096-2.753.445-.828-.474-1.472-1.181-1.755-2.023zM19.695 36.036l1.479.127-.333 4.055 2.597.22-.106 1.295-4.083-.333.446-5.364zM26.142 35.731l1.366-.431 3.815 4.472-1.529.481-.658-.8-1.982.623-.077 1.034-1.494.474.56-5.853zm2.237 2.746l-1.033-1.274-.12 1.642 1.153-.368zM30.084 34.196l.976-.99 3.58.424-2.023-1.996 1.033-1.054 3.828 3.779-.92.927-3.708-.432 2.095 2.067-1.033 1.054-3.828-3.779zM34.209 28.803l.913-1.86c.849-1.72 2.335-2.23 3.722-1.543l.014.007c1.387.686 1.925 2.208 1.069 3.941l-.899 1.833-4.819-2.378zm4.564-.084c.397-.8.22-1.543-.566-1.932l-.014-.007c-.771-.383-1.479-.071-1.875.729l-.27.544 2.456 1.21.27-.544z"
        fill="#fff"
      />
      <path
        d="M31.251 12.626h.884c.715 0 1.204.489 1.204 1.125v.008c0 .636-.489 1.132-1.203 1.132h-.885v-2.265zm.884 1.812c.411 0 .68-.276.68-.68v-.007c0-.403-.276-.679-.68-.679h-.382v1.366h.383zM33.643 14.027c0-.502.354-.906.856-.906.58 0 .842.453.842.941 0 .036-.007.085-.007.128h-1.203c.05.226.206.34.425.34.163 0 .283-.05.418-.178l.283.248a.879.879 0 01-.708.326c-.524 0-.906-.368-.906-.9zm1.217-.142c-.028-.219-.155-.368-.368-.368-.205 0-.34.149-.375.368h.743zM35.568 14.657l.212-.325c.191.134.382.205.545.205.142 0 .205-.05.205-.127 0-.106-.17-.142-.36-.198-.241-.071-.517-.184-.517-.524v-.007c0-.354.283-.552.637-.552.22 0 .46.078.644.198l-.191.34c-.17-.1-.34-.163-.468-.163-.12 0-.183.05-.183.12v.007c0 .1.162.142.353.206.241.077.524.198.524.516v.007c0 .382-.29.56-.665.56-.234 0-.503-.079-.736-.263zM37.252 14.028c0-.588.375-.906.793-.906.262 0 .425.12.538.262v-.857h.488v2.364h-.488v-.248a.633.633 0 01-.538.283c-.41-.007-.793-.325-.793-.898zm1.33 0c0-.298-.19-.489-.417-.489-.226 0-.424.191-.424.482v.007c0 .29.19.48.424.48.227-.006.418-.197.418-.48zM39.424 14.027c0-.502.354-.906.857-.906.58 0 .842.453.842.941 0 .036 0 .085-.007.128h-1.203c.05.226.205.34.424.34.163 0 .283-.05.418-.178l.283.248a.879.879 0 01-.708.326c-.523 0-.906-.368-.906-.9zm1.225-.142c-.029-.219-.156-.368-.368-.368-.206 0-.34.149-.375.368h.743zM31.266 16.463l-.793.198-.205-.82 1.31-.39h.686v4.586h-.991v-3.574h-.007zM33.325 19.576l.53-.764c.334.27.61.39.999.39.559 0 .856-.425.927-1.034-.22.191-.531.312-.927.312-.991 0-1.628-.545-1.628-1.472v-.014c0-.92.708-1.593 1.74-1.593.61 0 .97.149 1.317.496.326.325.538.82.538 1.72v.014c0 1.479-.694 2.483-1.988 2.483-.673 0-1.126-.219-1.508-.538zm2.463-2.604v-.014c0-.403-.297-.693-.8-.693-.495 0-.771.29-.771.693v.014c0 .404.297.687.792.687.496-.014.779-.297.779-.687zM38.06 19.626c-.333-.332-.538-.82-.538-1.727v-.014c0-1.408.636-2.484 1.995-2.484.616 0 1.02.184 1.422.503l-.523.771c-.297-.226-.538-.36-.934-.36-.566 0-.857.452-.92 1.054a1.58 1.58 0 01.94-.29c.907 0 1.6.502 1.6 1.45v.014c0 .934-.75 1.578-1.74 1.578-.58-.007-.984-.176-1.303-.495zm2.051-1.04v-.014c0-.383-.297-.665-.792-.665-.495 0-.779.276-.779.658v.014c0 .382.298.68.793.68.495-.008.779-.284.779-.673zM41.795 19.244l1.515-1.246c.566-.467.785-.715.785-1.097s-.255-.594-.608-.594c-.354 0-.595.198-.934.609l-.701-.567c.446-.615.885-.94 1.698-.94.942 0 1.571.551 1.571 1.407v.015c0 .764-.389 1.139-1.196 1.762l-.743.573h1.989v.863h-3.368v-.785h-.008z"
        fill="#003591"
      />
    </svg>

const CurveTop = (className, fill) =>
    <svg width={80} height={13} viewBox="0 0 80 13" fill="none" className={className}>
        <path
          d="M61.278 6.475c4.946 2.544 11.13 6.233 18.471 6.233H.686c7.42 0 13.602-4.237 18.548-6.493C24.181 3.958 32.837.208 40.256.208c7.42 0 16.076 3.722 21.022 6.267z"
          fill={fill}
        />
    </svg>
  
const CurveBottom = (className, fill) =>
    <svg width={80} height={13} viewBox="0 0 80 13" fill="none" className={className}>
        <path
          d="M19.257 6.238C14.31 3.693 8.127.005.785.005H79.85c-7.42 0-13.602 4.237-18.549 6.493-4.946 2.257-13.602 6.007-21.021 6.007-7.42 0-16.076-3.722-21.022-6.267z"
          fill={fill}
        />
    </svg>

const CurveSmall = (className, fill) =>
    <svg width={43} height={14} viewBox="0 0 43 14" className={className}>
    <path
      d="M10.011 6.747C7.383 9.425 4.1 13.307.198 13.307h42.006c-3.942 0-7.227-4.459-9.855-6.834C29.72 4.1 25.122.153 21.18.153s-8.54 3.916-11.169 6.594z"
      fill={fill}
    />
    </svg>

const IconBack = (className, fill) =>
    <svg
      width={30}
      height={29}
      viewBox="0 0 30 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.25 28.25C22.844 28.25 29 22.094 29 14.5S22.844.75 15.25.75 1.5 6.906 1.5 14.5s6.156 13.75 13.75 13.75z"
        stroke={fill}
        strokeWidth={1.5}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.956 10.155a.792.792 0 10-1.204-1.029l-3.765 4.406a.792.792 0 00-.097.888c.05.11.126.205.218.28l3.647 4.21a.792.792 0 001.197-1.038L12.36 14.88h8.551a.792.792 0 100-1.584h-8.639l2.684-3.14z"
        fill={fill}
      />
    </svg>

const IconHome = (className, fill) =>
    <svg width={33}  height={32} viewBox="0 0 33 32" fill="none" className={className}>
    <path
      d="M16.052 2.98c.86.006 1.63.384 2.28.952l.035.032 11.8 11.265a1.067 1.067 0 01-.736 1.838h-3.234v10.667c0 .589-.477 1.066-1.066 1.066h-6.4c-.59 0-1.067-.477-1.067-1.066v-7.467h-3.2v7.467c0 .589-.478 1.066-1.067 1.066H6.964c-.59 0-1.067-.477-1.067-1.066V17.067H2.731a1.067 1.067 0 01-.74-1.835l11.7-11.265.036-.033c.675-.592 1.46-.961 2.325-.954zm-.9 2.542l-9.775 9.412h1.587c.59 0 1.067.477 1.067 1.066v10.667h4.3V19.2c0-.589.477-1.066 1.066-1.066h5.334c.589 0 1.066.477 1.066 1.066v7.467h4.267V16a1.066 1.066 0 011.067-1.066h1.638l-9.856-9.41c-.375-.322-.667-.41-.878-.411-.208-.002-.5.078-.883.41z"
      fill={fill}
    />
  </svg>

const IconStar = (className, fill) =>
    <svg width={20} height={20} viewBox="0 0 26 26" fill="none" className={className}>
        <path
          d="M11.665 3.733c.499-1.536 2.671-1.536 3.17 0l1.827 5.622h5.912c1.614 0 2.285 2.066.98 3.015l-4.783 3.475 1.826 5.622c.5 1.536-1.258 2.812-2.564 1.863l-4.783-3.474-4.782 3.474c-1.307.95-3.064-.327-2.565-1.863l1.827-5.622-4.783-3.475c-1.306-.949-.635-3.015.98-3.015h5.911l1.827-5.622zm3.412 6.137L13.25 4.248 11.423 9.87a1.667 1.667 0 01-1.585 1.152H3.927l4.782 3.474c.584.425.829 1.177.606 1.864l-1.827 5.622 4.782-3.475a1.667 1.667 0 011.96 0l4.782 3.475-1.826-5.622a1.667 1.667 0 01.605-1.864l4.783-3.474h-5.912a1.667 1.667 0 01-1.585-1.152z"
          fill={fill}
        />
    </svg>
  
const IconCampana = (className, fill) =>
    <svg width={26} height={26} viewBox="0 0 26 26" fill="none" className={className}>
        <path
          d="M10.093 19.936a.833.833 0 01.833-.816h4.648c.454 0 .824.363.833.816v.008a3.158 3.158 0 11-6.315.025v-.033zm1.91.851a1.49 1.49 0 002.494 0h-2.494z"
          fill={fill}
        />
        <path
          d="M11.372 4.989a1.878 1.878 0 013.756 0v.536a6.164 6.164 0 014.284 5.87v3.577l1.948 2.862a1.89 1.89 0 01-1.563 2.953H6.703a1.89 1.89 0 01-1.563-2.953l1.948-2.861v-3.577c0-2.75 1.799-5.076 4.284-5.87v-.537zm1.878-.212a.212.212 0 00-.212.212v1.18c0 .398-.28.74-.67.818a4.497 4.497 0 00-3.614 4.409v3.834c0 .167-.05.33-.144.469L6.518 18.77a.223.223 0 00.185.35h13.094a.223.223 0 00.185-.35l-2.092-3.073a.834.834 0 01-.144-.468v-3.834c0-2.18-1.553-4-3.613-4.41a.833.833 0 01-.671-.817V4.99a.212.212 0 00-.212-.212z"
          fill={fill}
        />
    </svg>
  
const IconCarrito = (className) =>
    <svg width={26} height={26} viewBox="0 0 26 26" fill="none" className={className}>
        <path
          d="M1.479 4.264c0-.46.373-.833.833-.833h2.032c.402 0 .746.287.82.682L7.745 18.12H20.54a.833.833 0 110 1.666H7.051a.833.833 0 01-.819-.682L3.65 5.098H2.312a.833.833 0 01-.833-.834z"
        />
        <path
          d="M4.76 6.66c0-.46.373-.833.834-.833H23.04a.833.833 0 01.815 1.01l-1.98 9.115a.833.833 0 01-.814.656H6.583a.833.833 0 110-1.666h13.808l1.617-7.448H5.594a.833.833 0 01-.834-.834zM8.74 19.008c.46 0 .834.373.834.833a1.094 1.094 0 102.187 0 .833.833 0 011.667 0 2.76 2.76 0 11-5.52 0c0-.46.372-.833.833-.833zM15.181 19.008c.46 0 .834.373.834.833a1.094 1.094 0 102.187 0 .833.833 0 011.667 0 2.76 2.76 0 11-5.52 0c0-.46.372-.833.832-.833z"
        />
    </svg>

  
const IconMenu = (className) =>
    <svg width={26} height={26} viewBox="0 0 26 26" fill="none" className={className}>
        <path
          d="M23.771 4.743H2.729M23.771 10.327H2.729M23.771 15.91H2.729M23.771 21.494H2.729"
          stroke="#316ACD"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
    </svg>

const IconClose = (className, fill) =>
    <svg width={37} height={36} viewBox="0 0 37 36" fill="none" className={className}>
        <path
          d="M23.79 12.776a.833.833 0 010 1.178l-9.612 9.613a.833.833 0 01-1.179-1.179l9.612-9.612a.833.833 0 011.179 0z" fill={fill}
        />
        <path
          d="M23.79 23.567a.833.833 0 01-1.178 0l-9.613-9.612a.833.833 0 011.179-1.179l9.612 9.613a.833.833 0 010 1.178z" fill={fill}
        />
    </svg>

const IconChart = (className, fill) =>
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none" className={className}>
        <g clipPath="url(#prefix__clip0)">
          <path
            d="M2.878 12.59c0-.369.298-.667.667-.667h2.791c.368 0 .667.298.667.666v4.371a.667.667 0 01-.667.667H3.545a.667.667 0 01-.667-.667v-4.37zm1.333.666v3.038H5.67v-3.038H4.211zM8.08 10.092c0-.368.299-.666.667-.666h2.791c.368 0 .667.298.667.666v6.868a.667.667 0 01-.667.667H8.747a.667.667 0 01-.667-.667v-6.868zm1.333.667v5.535h1.458v-5.535H9.413zM13.283 5.685c0-.368.298-.667.666-.667h2.792c.368 0 .666.299.666.667V16.96a.667.667 0 01-.666.667h-2.792a.667.667 0 01-.666-.667V5.685zm1.333.666v9.943h1.458V6.35h-1.458z"
            fill={fill}
          />
          <path
            d="M.919 16.96c0-.368.298-.666.667-.666h17.189a.667.667 0 010 1.333H1.585a.667.667 0 01-.666-.667z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="prefix__clip0">
            <path
              fill="#fff"
              transform="matrix(0 1 1 0 .18 .942)"
              d="M0 0h20v20H0z"
            />
          </clipPath>
        </defs>
    </svg>

const IconOferta = (className, fill) =>
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" className={className}>
      <g
        clipPath="url(#prefix__clip0)"
      >
        <path d="M6.726 6.375a.19.19 0 100 .38.19.19 0 000-.38zm-1.19.19a1.19 1.19 0 112.38 0 1.19 1.19 0 01-2.38 0zM9.628 9.533a.19.19 0 100 .38.19.19 0 000-.38zm-1.19.19a1.19 1.19 0 112.38 0 1.19 1.19 0 01-2.38 0zM10.97 5.75a.5.5 0 01-.047.706l-5.187 4.546a.5.5 0 01-.66-.752l5.188-4.546a.5.5 0 01.706.047z" fill={fill}/>
        <path d="M5.59 1.79a.5.5 0 01.668-.206l2.273 1.172 2.452-.729a.5.5 0 01.618.327l.78 2.436 2.248 1.219a.5.5 0 01.206.668l-1.172 2.274.729 2.45a.5.5 0 01-.327.62l-2.436.778-1.219 2.249a.5.5 0 01-.668.206l-2.274-1.171-2.45.728a.5.5 0 01-.62-.327l-.779-2.436-2.248-1.219a.5.5 0 01-.206-.668l1.171-2.273-.728-2.452a.5.5 0 01.327-.618l2.436-.78L5.589 1.79zm.645.907l-1.08 1.995a.5.5 0 01-.288.238l-2.16.691.645 2.175a.5.5 0 01-.035.371l-1.039 2.017 1.995 1.08a.5.5 0 01.238.288l.69 2.16 2.175-.645a.5.5 0 01.372.034l2.016 1.04 1.081-1.995a.5.5 0 01.288-.238l2.16-.69-.646-2.175a.5.5 0 01.035-.372l1.04-2.016-1.995-1.081a.5.5 0 01-.238-.288l-.691-2.16-2.175.646a.5.5 0 01-.371-.035l-2.017-1.04z" fill={fill}/>
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path
            transform="matrix(0 1 1 0 .5 .919)"
            d="M0 0h15v15H0z"
          />
        </clipPath>
      </defs>
    </svg>

const IconArrowRight = (className, fill) =>
    <svg width={15} height={14} className={className} viewBox="0 0 19 16" fill="none">
      <path
        d="M10.804 13.2a1.108 1.108 0 00.134 1.62c.51.412 1.277.356 1.713-.127l5.773-6.395c.328-.365.379-.874.151-1.283a1.165 1.165 0 00-.34-.416L12.646.492a1.263 1.263 0 00-1.713-.115 1.108 1.108 0 00-.123 1.621l3.976 4.342H1.672c-.67 0-1.214.515-1.214 1.15 0 .635.543 1.15 1.214 1.15H14.92l-4.115 4.56z"
        fill={fill}
      />
    </svg>

const IconArrowLeft = (className, fill) =>
    <svg width={30} height={29} viewBox="0 0 30 29" fill="none" className={className}>
      <path
        d="M15.25 28.25C22.844 28.25 29 22.094 29 14.5S22.844.75 15.25.75 1.5 6.906 1.5 14.5s6.156 13.75 13.75 13.75z"
        stroke={fill}
        strokeWidth={1.5}
        fill="none"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.956 10.155a.792.792 0 10-1.204-1.029l-3.765 4.406a.792.792 0 00-.097.888c.05.11.126.205.218.28l3.647 4.21a.792.792 0 001.197-1.038L12.36 14.88h8.551a.792.792 0 100-1.584h-8.639l2.684-3.14z"
        fill={fill}
      />
    </svg>

const IconTrofeo = (className) =>
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" className={className}>
      <g
        clipPath="url(#prefix__clip0)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2DB997"
      >
        <path d="M4.693 12.028a.5.5 0 01.5-.5h5.813a.5.5 0 01.5.5v2.875a.5.5 0 01-.5.5H5.193a.5.5 0 01-.5-.5v-2.875zm1 .5v1.875h4.813v-1.875H5.693zM4.709 2.027a.5.5 0 01.5-.5h5.781a.5.5 0 01.5.5v4.688a3 3 0 01-3 3H7.71a3 3 0 01-3-3V2.027zm1 .5v4.188a2 2 0 002 2h.781a2 2 0 002-2V2.527H5.71z" />
        <path d="M8.1 8.777a.5.5 0 01.5.5v2.47a.5.5 0 01-1 0v-2.47a.5.5 0 01.5-.5zM11.883 3.775c-.173.037-.372.182-.5.33a.5.5 0 01-.756-.655c.206-.237.582-.555 1.05-.653.247-.052.525-.044.8.079.275.12.508.336.698.63.244.376.258.788.16 1.158-.094.357-.296.695-.52.987-.451.587-1.084 1.109-1.526 1.413a.5.5 0 11-.567-.824c.39-.268.934-.721 1.3-1.198.183-.239.3-.455.347-.634.044-.166.023-.273-.033-.359-.11-.169-.204-.233-.263-.259a.298.298 0 00-.19-.015zM4.103 3.775c.174.037.372.182.5.33a.5.5 0 00.756-.655c-.205-.237-.582-.555-1.05-.653a1.296 1.296 0 00-.8.079c-.275.12-.507.336-.698.63-.244.376-.258.788-.16 1.158.094.357.296.695.52.987.452.587 1.084 1.109 1.527 1.413a.5.5 0 00.566-.824c-.39-.268-.933-.721-1.3-1.198-.183-.239-.3-.455-.347-.633-.043-.167-.022-.274.033-.36.11-.169.204-.233.263-.259a.298.298 0 01.19-.015z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path
            fill="#fff"
            transform="matrix(0 1 1 0 .493 .965)"
            d="M0 0h15v15H0z"
          />
        </clipPath>
      </defs>
    </svg>

const IconList = (className,fill) =>
    <svg width={25} height={26} viewBox="0 0 25 26" fill="none" className={className}>
      <path
        d="M6.042 4.573a.833.833 0 00-.833.834V20.77c0 .46.373.834.833.834h12.916c.46 0 .834-.374.834-.834V5.407a.833.833 0 00-.834-.834h-3.26V6.24h2.427v13.698H6.875V6.24h2.426V4.573h-3.26z"
        fill={fill}
      />
      <path
        d="M8.468 3.627c0-.46.373-.833.833-.833H15.7c.46 0 .833.373.833.833v3.23c0 .46-.373.833-.833.833H9.3a.833.833 0 01-.833-.834V3.627zm1.666.834v1.562h4.731V4.461h-4.73z"
        fill={fill}
      />
      <path
        d="M10.557 11.428a.846.846 0 10-1.692 0 .846.846 0 001.692 0zM10.557 14.749a.846.846 0 10-1.692 0 .846.846 0 001.692 0z"
        fill={fill}
      />
      <path
        d="M11.483 11.428c0-.46.373-.833.834-.833h3.382a.833.833 0 010 1.667h-3.382a.833.833 0 01-.834-.834zM11.483 14.749c0-.46.373-.834.834-.834h3.382a.833.833 0 010 1.667h-3.382a.833.833 0 01-.834-.833z"
        fill={fill}
      />
    </svg>

const IconList2 = (className,fill) =>
    <svg width={26} height={26} viewBox="0 0 26 26" fill="none" className={className} >
    <g clipPath="url(#prefix__clip0)" fill="#316ACD">
        <path
          d="M.58 1.804c0-.46.373-.833.833-.833h23.23c.46 0 .833.373.833.833v23.203c0 .46-.373.834-.833.834H1.413a.833.833 0 01-.833-.834V1.804zm1.667.834v21.536h21.562V2.638H2.247z"
          fill={fill}
        />
        <path d="M9.754 7.403a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zM9.754 13.289a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zM9.754 19.174a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0z" fill={fill}/>
        <path
          d="M12.143 7.403c0-.46.373-.833.833-.833h5.797a.833.833 0 010 1.666h-5.797a.833.833 0 01-.833-.833zM12.143 13.289c0-.46.373-.834.833-.834h5.797a.833.833 0 010 1.667h-5.797a.833.833 0 01-.833-.833zM12.143 19.174c0-.46.373-.833.833-.833h5.797a.833.833 0 010 1.666h-5.797a.833.833 0 01-.833-.833z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path
            fill="#fff"
            transform="matrix(0 1 1 0 .514 .925)"
            d="M0 0h25v25H0z"
          />
        </clipPath>
      </defs>
    </svg>

const IconListCheck = (className,fill) =>
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none" className={className}>
    <path
      d="M5.013 3.866a.667.667 0 00-.666.667v12.292c0 .368.298.666.666.666h10.334a.667.667 0 00.666-.666V4.533a.667.667 0 00-.666-.667h-2.608V5.2h1.941v10.958h-9V5.2h1.941V3.866H5.013z"
      fill={fill}
    />
    <path
      d="M6.955 3.11c0-.368.298-.667.666-.667h5.118c.368 0 .667.299.667.667v2.583a.667.667 0 01-.667.667H7.621a.667.667 0 01-.666-.667V3.11zm1.333.666v1.25h3.785v-1.25H8.288zM13.105 8.405a.667.667 0 01.03.942l-3.348 3.575a.667.667 0 01-.994-.023L7.481 11.36a.667.667 0 111.014-.865l.829.971 2.838-3.03a.667.667 0 01.943-.031z"
      fill={fill}
    />
    </svg>

const IconTag = (className) =>
    <svg width={46} height={47} viewBox="0 0 46 47" fill="none" className={className}>
      <path
        d="M0 46.476l46-46H8.202C1.995.476.148 6.5 0 9.513v36.963z"
        fill="#FFC700"
      />
    </svg>

const IconAddCart = (className) =>
    <svg width={30} height={30} viewBox="0 0 34 31" fill="none" className={className}>
      <path
        d="M15.563 30.084c8.284 0 15-6.716 15-15 0-8.285-6.716-15-15-15-8.285 0-15 6.715-15 15 0 8.284 6.715 15 15 15z"
        fill="#F23361"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.083 8.158c0-.368.299-.667.667-.667h1.625c.322 0 .597.23.655.546l2.067 11.204h10.236a.667.667 0 010 1.334H10.542a.667.667 0 01-.656-.546L7.82 8.825H6.75a.667.667 0 01-.667-.667z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.708 10.075c0-.369.299-.667.667-.667h13.958a.667.667 0 01.652.808L22.4 17.508a.667.667 0 01-.651.525H10.167a.667.667 0 010-1.333h11.045l1.294-5.959H9.375a.667.667 0 01-.667-.666zM11.892 19.953c.368 0 .667.298.667.666a.875.875 0 001.75 0 .667.667 0 011.333 0 2.208 2.208 0 01-4.416 0c0-.368.298-.666.666-.666zM17.045 19.953c.368 0 .667.298.667.666a.875.875 0 101.75 0 .667.667 0 111.333 0 2.208 2.208 0 01-4.417 0c0-.368.299-.666.667-.666z"
        fill="#fff"
      />
      <path d="M34 6.083a6 6 0 10-12 0 6 6 0 0012 0z" fill="#FFC700" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 2.724a.65.65 0 01.65.65v5.417a.65.65 0 11-1.3 0V3.374a.65.65 0 01.65-.65z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.359 6.083a.65.65 0 01-.65.65h-5.417a.65.65 0 110-1.3h5.417a.65.65 0 01.65.65z"
        fill="#fff"
      />
    </svg>

const IconCart = (className, fill) =>
    <svg width={26} height={25} viewBox="0 0 26 25" fill="none" className={className}>
      <path
        d="M1.285 3.646c0-.46.373-.833.833-.833h2.031c.402 0 .747.286.82.682L7.55 17.5h12.796a.833.833 0 010 1.667H6.857a.833.833 0 01-.819-.683L3.456 4.48H2.118a.833.833 0 01-.833-.833z"
        fill={fill}
      />
      <path
        d="M4.566 6.042c0-.46.373-.833.833-.833h17.448a.833.833 0 01.815 1.01l-1.98 9.114a.833.833 0 01-.814.657H6.39a.833.833 0 110-1.667h13.807l1.618-7.448H5.399a.833.833 0 01-.833-.833zM8.546 18.39c.46 0 .833.372.833.832a1.094 1.094 0 102.188 0 .833.833 0 011.666 0 2.76 2.76 0 01-5.52 0c0-.46.373-.833.833-.833zM14.987 18.39c.46 0 .833.372.833.832a1.094 1.094 0 002.188 0 .833.833 0 011.666 0 2.76 2.76 0 01-5.52 0c0-.46.373-.833.833-.833z"
        fill={fill}
      />
    </svg>

const IconReloj = (className, fill) =>
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" className={className}>
      <path
        d="M7.821 4.86a3.426 3.426 0 100 6.853 3.426 3.426 0 000-6.853zM3.395 8.287a4.426 4.426 0 118.853 0 4.426 4.426 0 01-8.853 0z"
        fill={fill}
      />
      <path
        d="M7.523 5.866a.5.5 0 01.5.5V8.12H9.49a.5.5 0 110 1H7.523a.5.5 0 01-.5-.5V6.366a.5.5 0 01.5-.5zM10.025 11.088a.5.5 0 01.706.035l1.367 1.509a.5.5 0 01-.741.671L9.99 11.795a.5.5 0 01.035-.707zM5.774 11.194a.5.5 0 01-.035.706l-1.508 1.367a.5.5 0 11-.672-.74l1.509-1.368a.5.5 0 01.706.035zM11.203 2.81c.544-.089 1.158.053 1.714.597.558.547.706 1.159.614 1.706a2.155 2.155 0 01-.618 1.158.5.5 0 01-.697-.006L10.047 4.12a.5.5 0 01-.006-.705c.235-.24.647-.52 1.162-.605zm-.014 1.033l1.304 1.29a.976.976 0 00.052-.186c.037-.22 0-.504-.328-.825-.33-.323-.624-.362-.853-.325-.06.01-.12.026-.175.046zM2.108 5.05c-.09-.544.052-1.157.597-1.714.546-.558 1.158-.706 1.705-.614.514.087.926.375 1.158.618a.5.5 0 01-.006.698L3.417 6.206a.5.5 0 01-.705.006 2.168 2.168 0 01-.604-1.161zm1.032.014L4.43 3.76a.97.97 0 00-.186-.052c-.22-.037-.504 0-.825.328-.323.33-.362.624-.324.853.01.06.025.12.045.175z"
        fill={fill}
      />
    </svg>

const IconClip = (className, fill) =>
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none" className={className}>
      <path
        d="M7.526 4.65v10.4c0 1.49 1.301 2.679 3.01 2.679 1.696 0 2.938-1.137 2.938-2.68V5.835a.667.667 0 011.333 0v9.214c0 2.4-1.965 4.013-4.272 4.013-2.294 0-4.342-1.644-4.342-4.013V4.606c.02-.484.192-1.184.656-1.78.486-.626 1.266-1.098 2.39-1.098 1.123 0 1.914.47 2.421 1.08.487.587.695 1.28.74 1.763l.004.031v8.703c0 .428-.154.896-.492 1.264-.35.382-.865.618-1.5.618-.63 0-1.142-.227-1.49-.617a1.903 1.903 0 01-.467-1.265v-7.47a.667.667 0 011.333 0v7.47c0 .15.05.288.13.378.067.075.2.17.494.17.287 0 .436-.097.518-.185a.551.551 0 00.14-.363V4.668a2.038 2.038 0 00-.436-1.008c-.266-.321-.689-.598-1.395-.598-.704 0-1.098.274-1.337.582a1.896 1.896 0 00-.376 1.005z"
        fill={fill}
      />
    </svg>

const IconAddFile = (className, fill) =>

    <svg width={25} height={26} viewBox="0 0 25 26" fill="none" className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.434 21.544a.833.833 0 01-.833-.834v-6.927a.833.833 0 011.667 0v6.927c0 .46-.373.834-.834.834z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.288 16.183a.833.833 0 01-1.173.109l-2.662-2.21-2.68 2.211a.833.833 0 01-1.062-1.285l3.213-2.65a.833.833 0 011.063 0l3.192 2.651c.355.294.403.82.11 1.174zM13.99 1.906c.46 0 .833.373.833.834v4.424c0 .496.089.813.214.99.087.121.26.279.767.279h4.913a.833.833 0 010 1.667h-4.913c-.929 0-1.662-.332-2.124-.98-.423-.593-.524-1.327-.524-1.956V2.74c0-.46.373-.834.834-.834z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.81 2.223c0-.46.374-.833.834-.833h8.409c.218 0 .428.086.584.24l7.194 7.072c.16.157.25.371.25.595v14.48c0 .46-.374.833-.834.833H5.644a.833.833 0 01-.833-.833V2.223zm1.667.834v19.886h13.937V9.646l-6.702-6.59H6.477z"
      fill={fill}
    />
    </svg>

const IconTrash = (className, fill) =>
    <svg width={20} height={21} viewBox="0 0 20 21" fill="none" className={className}>
      <path
        d="M8.385 9.834c.369 0 .667.298.667.666v4.542a.667.667 0 11-1.333 0V10.5c0-.368.298-.666.666-.666zM11.614 9.834c.369 0 .667.298.667.666v4.542a.667.667 0 01-1.333 0V10.5c0-.368.298-.666.666-.666zM8.013 2.093a.667.667 0 01.528-.26h3.162c.226 0 .437.115.56.305l.857 1.324H16c.368 0 .667.298.667.666v3.08a.667.667 0 01-.667.667H4a.667.667 0 01-.667-.667v-3.08c0-.368.299-.666.667-.666h2.956l1.057-1.37zm.855 1.074L7.812 4.536a.667.667 0 01-.528.259H4.667v1.747h10.666V4.795h-2.576a.667.667 0 01-.56-.304l-.857-1.324H8.868z"
        fill={fill}
      />
      <path
        d="M4.708 7.25c0-.368.299-.667.667-.667h9.292c.368 0 .667.299.667.667v9.5a2.667 2.667 0 01-2.667 2.667H7.375a2.667 2.667 0 01-2.667-2.667v-9.5zm1.334.667v8.833c0 .736.597 1.334 1.333 1.334h5.292c.736 0 1.333-.598 1.333-1.334V7.917H6.042z"
        fill={fill}
      />
    </svg>

const IconTrash2 = (className, fill) =>
    <svg width={27} height={22} fill="none" className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5 2.491a.815.815 0 0 1 .545.113l2.738 1.58c.196.114.34.286.382.458l.297 1.2 2.494 1.441c.32.184.477.508.353.722l-1.037 1.798c-.124.214-.483.24-.802.055l-10.393-6c-.319-.184-.476-.507-.352-.722l1.037-1.797c.124-.215.483-.24.802-.056l2.56 1.478 1.376-.27Zm.38 1.054-1.377.27a.816.816 0 0 1-.544-.112l-2.267-1.309-.588 1.02 9.237 5.333.589-1.02-2.232-1.288c-.195-.113-.34-.285-.382-.457l-.296-1.2-2.14-1.237ZM13.885 11.332c.369 0 .667.298.667.667v4.541a.667.667 0 0 1-1.333 0V12c0-.369.298-.667.666-.667ZM17.115 11.332c.368 0 .667.298.667.667v4.541a.667.667 0 0 1-1.334 0V12c0-.369.299-.667.667-.667Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.208 8.749c0-.368.299-.667.667-.667h9.291c.369 0 .667.299.667.667v9.5a2.667 2.667 0 0 1-2.667 2.666h-5.291a2.667 2.667 0 0 1-2.667-2.666v-9.5Zm1.333.666v8.834c0 .736.597 1.333 1.334 1.333h5.291c.737 0 1.334-.597 1.334-1.333V9.415H11.54ZM5.1 1.905c-2.25-.272-5 2-4.5 1.499C2.167 1.834 3.025.272 5.737.599c1.858.224 3.446 1.57 4.436 3.5.163.319.107.757-.127.98-.233.223-.554.145-.718-.173C8.505 3.3 6.641 2.09 5.1 1.905Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.367 1.59c.284 0 .515.314.515.702v3.482a.832.832 0 0 1-.177.53c-.112.134-.262.195-.41.167l-2.407-.456c-.282-.053-.479-.409-.44-.793.04-.385.3-.653.582-.6l1.821.345V2.292c0-.388.23-.703.515-.703Z"
      fill={fill}
    />
    </svg>

const IconRefresh = (className,fill) =>
    <svg width={20} height={21} viewBox="0 0 20 21" fill="none" className={className}>
      <path
        d="M9.355 16.497a6.51 6.51 0 006.593-4.01.667.667 0 011.234.505 7.843 7.843 0 01-13.681 1.514.667.667 0 011.093-.764 6.49 6.49 0 004.76 2.755zM10.617 5.315a6.51 6.51 0 00-6.594 4.01.667.667 0 11-1.234-.505 7.843 7.843 0 0113.682-1.514.667.667 0 01-1.093.764 6.49 6.49 0 00-4.761-2.755z"
        fill={fill}
      />
      <path
        d="M3.28 17.107a.667.667 0 01-.667-.667v-3.301a.666.666 0 01.758-.66l3.113.431a.667.667 0 01-.183 1.321l-2.355-.327v2.536a.667.667 0 01-.666.666zM16.72 4.705c.368 0 .667.299.667.667v3.301a.667.667 0 01-.759.66l-3.113-.432a.667.667 0 01.184-1.32l2.354.326V5.372c0-.368.299-.667.667-.667z"
        fill={fill}
      />
    </svg>

const IconCodigo = (className,fill) =>
    <svg width={41} height={41} viewBox="0 0 41 41" fill="none" className={className}>
      <path fill="#fff" d="M.418.177v40h40v-40z" />
      <path
        d="M3.292 8.221c0-.736.597-1.333 1.333-1.333h6.646a1.333 1.333 0 110 2.666H5.958v5.362a1.333 1.333 0 11-2.666 0V8.22zM37.545 32.132c0 .736-.597 1.333-1.333 1.333h-6.646a1.333 1.333 0 110-2.666h5.313v-5.362a1.333 1.333 0 012.666 0v6.695zM36.212 6.912c.736 0 1.333.597 1.333 1.333v6.646a1.333 1.333 0 11-2.666 0V9.579h-5.362a1.333 1.333 0 110-2.667h6.695zM4.625 33.439a1.333 1.333 0 01-1.333-1.333V25.46a1.333 1.333 0 112.666 0v5.312h5.362a1.333 1.333 0 110 2.667H4.625zM10.835 13.01c.736 0 1.333.597 1.333 1.333v11.666a1.333 1.333 0 01-2.666 0V14.343c0-.736.596-1.334 1.333-1.334zM20.418 13.01c.736 0 1.333.597 1.333 1.333v11.666a1.333 1.333 0 11-2.666 0V14.343c0-.736.597-1.334 1.333-1.334zM25.21 13.01c.736 0 1.333.597 1.333 1.333v6.5a1.333 1.333 0 01-2.666 0v-6.5c0-.736.597-1.334 1.333-1.334zM15.627 13.01c.736 0 1.333.597 1.333 1.333v4.708a1.333 1.333 0 11-2.667 0v-4.708c0-.736.597-1.334 1.334-1.334zM25.21 23.29c.736 0 1.333.598 1.333 1.334v1.386a1.333 1.333 0 01-2.666 0v-1.386c0-.736.597-1.333 1.333-1.333zM15.627 21.76c.736 0 1.333.596 1.333 1.333v2.916a1.333 1.333 0 11-2.667 0v-2.916c0-.736.597-1.334 1.334-1.334zM30.002 13.01c.736 0 1.333.597 1.333 1.333v11.666a1.333 1.333 0 11-2.666 0V14.343c0-.736.596-1.334 1.333-1.334z"
        fill={fill}
      />
    </svg>

const IconMoto = (className,fill) =>
    <svg width={41} height={41} viewBox="0 0 41 41" fill="none" className={className}>
      <g clipPath="url(#prefix__clip0)">
        <path fill="#fff" d="M.75.177v40h40v-40z" />
        <path
          d="M20.75 3.16a3.451 3.451 0 100 6.903 3.451 3.451 0 000-6.903zm-6.118 3.451a6.118 6.118 0 1112.236 0 6.118 6.118 0 01-12.236 0z"
          fill={fill}
        />
        <path
          d="M24.201 6.593c0-.737.597-1.333 1.334-1.333h7.524a1.333 1.333 0 010 2.666h-7.524A1.333 1.333 0 0124.2 6.593zM7.107 6.593c0-.737.597-1.333 1.334-1.333h7.524a1.333 1.333 0 110 2.666H8.441a1.333 1.333 0 01-1.334-1.333zM16.335 30.243a4.415 4.415 0 118.83 0v5.003a4.415 4.415 0 11-8.83 0v-5.003zm4.415-1.748c-.966 0-1.748.783-1.748 1.748v5.003a1.748 1.748 0 003.496 0v-5.003c0-.965-.782-1.748-1.748-1.748z"
          fill={fill}
        />
        <path
          d="M20.75 10.063a8.73 8.73 0 00-8.73 8.73v13.926c0 .736.598 1.333 1.334 1.333H18v-2.666h-3.313V18.791a6.063 6.063 0 0112.125 0v12.593h-2.98v2.667h4.314c.736 0 1.333-.597 1.333-1.333V18.792a8.73 8.73 0 00-8.73-8.729z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path
            fill="#fff"
            transform="matrix(0 1 1 0 .75 .177)"
            d="M0 0h40v40H0z"
          />
        </clipPath>
      </defs>
    </svg>

const IconLupa = (className,fill) =>
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none" className={className}>
      <path
        d="M9.05 4.06c-2.73 0-4.943 2.203-4.943 4.922 0 2.72 2.213 4.924 4.942 4.924 2.73 0 4.943-2.205 4.943-4.924 0-2.719-2.213-4.923-4.943-4.923zM2.767 8.981c0-3.455 2.812-6.256 6.281-6.256 3.47 0 6.281 2.801 6.281 6.256 0 3.456-2.812 6.257-6.28 6.257-3.47 0-6.282-2.801-6.282-6.257z"
        fill={fill}
      />
      <path
        d="M12.572 12.67a.671.671 0 01.946-.012l3.493 3.396c.265.257.27.68.011.943a.671.671 0 01-.946.011l-3.493-3.396a.665.665 0 01-.011-.943z"
        fill={fill}
      />
    </svg>

const IconLeft = (className,fill) =>
    <svg width={25} height={26} viewBox="0 0 25 26" fill="none" className={className}>
      <path
        d="M16.934 3.767c.56.464.636 1.294.172 1.854l-6.49 7.817 6.492 7.87a1.317 1.317 0 11-2.031 1.676l-7.186-8.71a1.317 1.317 0 01.003-1.68L15.08 3.94a1.317 1.317 0 011.854-.172z"
        fill={fill}
      />
    </svg>

const IconRight = (className,fill) =>
    <svg width={25} height={26} viewBox="0 0 25 26" fill="none" className={className}>
      <path
        d="M8.066 23.16a1.317 1.317 0 01-.172-1.855l6.49-7.817-6.492-7.87a1.317 1.317 0 012.031-1.676l7.186 8.71a1.317 1.317 0 01-.003 1.68L9.92 22.986a1.317 1.317 0 01-1.854.172z"
        fill={fill}
      />
    </svg>

const IconBottom = (className,fill) =>
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none" className={className}>
    <path
      d="M2.251 6.615a1.053 1.053 0 011.484-.138l6.254 5.192 6.295-5.194A1.053 1.053 0 1117.625 8.1l-6.968 5.75c-.39.321-.954.32-1.343-.003L2.389 8.098a1.053 1.053 0 01-.138-1.483z"
      fill={fill}
    />
    </svg>

const IconTop = (className,fill) =>
  <svg width={21} height={21} viewBox="0 0 21 21" fill="none" className={className}>
  <path
    d="M18.599 13.628a1.053 1.053 0 01-1.484.138l-6.253-5.192-6.296 5.194a1.054 1.054 0 01-1.341-1.625l6.968-5.75c.39-.321.954-.32 1.344.003l6.924 5.749c.448.372.51 1.036.138 1.483z"
    fill={fill}
  />
  </svg>

const IconDownloadFile = (className,fill) =>
    <svg width={15} height={16} viewBox="0 0 15 16" fill="none" className={className}>
      <g
        clipPath="url(#prefix__clip0)"
        fill={fill}
      >
        <path d="M8.073 7.844a.5.5 0 01.5.5V12.5a.5.5 0 01-1 0V8.344a.5.5 0 01.5-.5z" />
        <path d="M5.76 11.06a.5.5 0 01.705-.065l1.597 1.326 1.609-1.327a.5.5 0 01.636.771l-1.928 1.59a.5.5 0 01-.637 0l-1.916-1.59a.5.5 0 01-.065-.705zM8.394 1.688a.5.5 0 01.5.5v2.654c0 .298.054.488.129.594.052.073.156.167.46.167h2.948a.5.5 0 010 1H9.483c-.557 0-.997-.198-1.274-.587-.254-.356-.315-.796-.315-1.174V2.188a.5.5 0 01.5-.5z" />
        <path d="M2.886 1.878a.5.5 0 01.5-.5h5.045a.5.5 0 01.35.143l4.317 4.244a.5.5 0 01.15.357v8.688a.5.5 0 01-.5.5H3.386a.5.5 0 01-.5-.5V1.877zm1 .5v11.931h8.362V6.332L8.227 2.378H3.886z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path
            fill="#fff"
            transform="matrix(0 1 1 0 0 .844)"
            d="M0 0h15v15H0z"
          />
        </clipPath>
      </defs>
    </svg>

const IconEnvio = (className,fill) =>
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none" className={className}>
      <path
        d="M7.189 13.034a1.083 1.083 0 100 2.167 1.083 1.083 0 000-2.167zm-2.417 1.084a2.417 2.417 0 114.833 0 2.417 2.417 0 01-4.833 0zM14.94 13.034a1.083 1.083 0 100 2.167 1.083 1.083 0 000-2.167zm-2.416 1.084a2.417 2.417 0 114.833 0 2.417 2.417 0 01-4.833 0z"
        fill={fill}
      />
      <path
        d="M12.436 5.65c0-.37.298-.668.666-.668h2.875c.257 0 .49.147.601.378l1.593 3.309 1.122 1.421a.667.667 0 01.143.413v3.688a.667.667 0 01-.667.666h-1.913a.667.667 0 110-1.333h1.246v-2.79L17.08 9.438a.664.664 0 01-.077-.124l-1.443-2.997h-2.457a.667.667 0 01-.666-.667zm-9.583 8.54c0-.367.298-.666.666-.666h1.298a.667.667 0 010 1.333H3.519a.667.667 0 01-.666-.666zm5.61 0c0-.367.298-.666.666-.666h3.973a.667.667 0 010 1.333H9.13a.667.667 0 01-.666-.666z"
        fill={fill}
      />
      <path
        d="M2.874 4.44c0-.367.298-.666.666-.666h9.438c.368 0 .666.299.666.667v3.958h3.792a.667.667 0 110 1.334h-4.458a.667.667 0 01-.667-.667V5.107h-8.77a.667.667 0 01-.667-.666z"
        fill={fill}
      />
      <path
        d="M2.207 6.816c0-.368.298-.667.666-.667h4.854a.667.667 0 010 1.333H2.873a.667.667 0 01-.666-.666zM1.24 9.013c0-.368.298-.667.666-.667h4.855a.667.667 0 110 1.334H1.906a.667.667 0 01-.666-.667zM2.031 11.244c0-.368.299-.667.667-.667h2.74a.667.667 0 010 1.334h-2.74a.667.667 0 01-.667-.667z"
        fill={fill}
      />
    </svg>

const IconLocal = (className,fill) =>
    <svg width={10} height={10} viewBox="0 0 21 21" fill="none" className={className}>
      <path
        d="M3.292 9.728c.368 0 .667.298.667.666v7.083h12.503v-7.083a.667.667 0 011.334 0v7.75a.667.667 0 01-.667.666H3.292a.667.667 0 01-.667-.667v-7.749c0-.368.299-.666.667-.666z"
        fill={fill}
      />
      <path
        d="M6.302 13.333c0-.368.298-.666.667-.666h6.642c.368 0 .666.298.666.666v4.81a.667.667 0 11-1.333 0V14H7.635v4.143a.667.667 0 11-1.333 0v-4.81zM4.024 2.66a.667.667 0 01.573-.325h11.306c.235 0 .453.124.573.325l2.847 4.784a.666.666 0 01-.573 1.008h-17a.667.667 0 01-.573-1.008L4.024 2.66zm.952 1.008l-2.054 3.45h14.655l-2.053-3.45H4.976z"
        fill={fill}
      />
      <path
        d="M1.75 7.355c.368 0 .667.299.667.667a1.468 1.468 0 002.936 0 .667.667 0 111.333 0 2.802 2.802 0 11-5.603 0c0-.368.299-.667.667-.667z"
        fill={fill}
      />
      <path
        d="M5.98 7.355c.368 0 .667.299.667.667a1.468 1.468 0 102.936 0 .667.667 0 111.334 0 2.802 2.802 0 11-5.604 0c0-.368.299-.667.667-.667z"
        fill={fill}
      />
      <path
        d="M10.21 7.355c.369 0 .667.299.667.667a1.468 1.468 0 102.937 0 .667.667 0 011.333 0 2.802 2.802 0 01-5.603 0c0-.368.298-.667.667-.667z"
        fill={fill}
      />
      <path
        d="M14.48 7.355c.368 0 .667.299.667.667a1.468 1.468 0 002.936 0 .667.667 0 111.334 0 2.802 2.802 0 01-5.604 0c0-.368.299-.667.667-.667z"
        fill={fill}
      />
    </svg>

const IconPago = (className,fill) =>
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none" className={className}>
      <g
        clipPath="url(#prefix__clip0)"
        fill={fill}
      >
        <path d="M9.36 16.614c0-.368.298-.666.666-.666h2.1a.667.667 0 010 1.333h-2.1a.667.667 0 01-.667-.666z" />
        <path d="M.973 10.685c0-.737.597-1.334 1.333-1.334h11.447c.736 0 1.333.597 1.333 1.334v7.595c0 .736-.597 1.333-1.334 1.333H2.306A1.333 1.333 0 01.973 18.28v-7.595zm12.78 0H2.306v7.595h11.447v-7.595z" />
        <path d="M1.297 13.371c0-.368.298-.667.667-.667H14.42a.667.667 0 110 1.334H1.964a.667.667 0 01-.667-.667zM14.648 9.063a.667.667 0 01.081-.94l1.608-1.351a.667.667 0 01.858 1.02l-1.608 1.352a.667.667 0 01-.94-.081z" />
        <path d="M4.345 10.131A1.333 1.333 0 014.47 8.21L13.21.864a1.333 1.333 0 011.879.163l4.886 5.814c.474.564.401 1.405-.163 1.879l-4.999 4.2a.667.667 0 11-.857-1.02l4.998-4.201-4.886-5.814-8.74 7.345.098.107a.667.667 0 11-.982.902l-.099-.108z" />
        <path d="M8.094 10.448a.667.667 0 01.08-.94l7.705-6.505a.667.667 0 11.86 1.02l-7.705 6.504a.667.667 0 01-.94-.079z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path
            fill={fill}
            transform="matrix(0 1 1 0 .727 .413)"
            d="M0 0h20v20H0z"
          />
        </clipPath>
      </defs>
    </svg>

const IconEdit= (className,fill) =>
    <svg width={15} height={16} viewBox="0 0 15 16" fill="none" className={className}>
      <path
        d="M11.96 2.688L6.524 8.215 6.01 9.787l1.758-.502 5.439-5.509a.356.356 0 00.103-.25c.003-.12-.038-.343-.325-.652-.265-.286-.491-.334-.643-.328a.674.674 0 00-.383.142zm.343-1.141c.467-.018.968.165 1.415.647.426.46.604.928.591 1.36-.012.414-.196.74-.397.931l-5.525 5.596a.5.5 0 01-.218.13l-2.79.796a.5.5 0 01-.612-.636l.844-2.578a.5.5 0 01.118-.196l5.532-5.625a1.664 1.664 0 011.042-.426z"
        fill={fill}
      />
      <path
        d="M10.558 2.982a.5.5 0 01.707-.004l1.711 1.687a.5.5 0 01-.702.712l-1.711-1.688a.5.5 0 01-.005-.707zM6.269 7.284a.5.5 0 01.707-.005l1.711 1.688a.5.5 0 11-.702.712L6.274 7.99a.5.5 0 01-.005-.707z"
        fill={fill}
      />
      <path
        d="M2.188 3.834a.5.5 0 00-.5.5v8.29a.5.5 0 00.5.5h8.874a.5.5 0 00.5-.5v-4.16a.5.5 0 011 0v4.16a1.5 1.5 0 01-1.5 1.5H2.188a1.5 1.5 0 01-1.5-1.5v-8.29a1.5 1.5 0 011.5-1.5h5.539a.5.5 0 110 1h-5.54z"
        fill={fill}
      />
    </svg>

const Iconcheck= (className,fill) =>
    <svg width={51} height={50} viewBox="0 0 51 50" fill="none" className={className}>
      <path
        d="M32.466 19.314c.672.629.706 1.684.077 2.355l-8.372 8.938a1.667 1.667 0 01-2.484-.058l-3.281-3.847a1.667 1.667 0 112.536-2.163l2.071 2.428 7.097-7.576a1.667 1.667 0 012.356-.077z"
        fill={fill}
      />
      <path
        d="M10.188 25c0-8.458 6.856-15.313 15.312-15.313 2.59 0 5.028.642 7.166 1.776l2.589-2.358A18.559 18.559 0 0025.5 6.353C15.203 6.353 6.854 14.701 6.854 25S15.203 43.645 25.5 43.645c10.298 0 18.646-8.348 18.646-18.646 0-3.775-1.122-7.288-3.05-10.224l-2.503 2.28a15.24 15.24 0 012.22 7.944c0 8.457-6.856 15.313-15.313 15.313-8.456 0-15.312-6.856-15.312-15.313z"
        fill={fill}
      />
    </svg>

const IconInfo= (className,fill) =>
    <svg width={20} height={21} viewBox="0 0 20 21" fill="none" className={className}>
      <path
        d="M10.35 4.209a6.125 6.125 0 100 12.25 6.125 6.125 0 000-12.25zm-7.457 6.125a7.458 7.458 0 1114.916 0 7.458 7.458 0 01-14.916 0z"
        fill={fill}
      />
      <path
        d="M10.382 8.299a.785.785 0 01-.568-.235.768.768 0 01-.251-.573c0-.224.088-.419.25-.573a.785.785 0 01.569-.235c.22 0 .414.082.57.238.156.156.238.35.238.57 0 .22-.082.414-.238.57a.786.786 0 01-.57.238zm-.414-.394a.707.707 0 01-.015-.015l.015.014z"
        fill={fill}
      />
      <path
        d="M9.514 9.738a.838.838 0 011.676 0v4.213a.838.838 0 01-1.676 0V9.738z"
        fill={fill}
      />
    </svg>

const IconUser= (className,fill) =>
    <svg width={41} height={41} viewBox="0 0 41 41" fill="none" className={className}>
      <path
        d="M20.964 7.689a5.367 5.367 0 100 10.735 5.367 5.367 0 000-10.735zm-8.034 5.367a8.034 8.034 0 1116.068 0 8.034 8.034 0 01-16.068 0zM9.785 27.094c1.844-2.825 5.103-4.888 10.91-4.888 5.58 0 8.878 2.099 10.869 4.864 1.598 2.221 2.298 4.836 2.782 6.642.09.334.171.64.25.912a1.334 1.334 0 01-1.28 1.706H8.566A1.333 1.333 0 017.27 34.68c.08-.325.157-.708.244-1.133.364-1.79.88-4.324 2.271-6.454zm.435 6.569h21.345c-.458-1.654-1.026-3.45-2.166-5.034-1.451-2.017-3.914-3.756-8.705-3.756-5.072 0-7.409 1.738-8.676 3.678-1.046 1.603-1.442 3.4-1.798 5.112z"
        fill={fill}
      />
    </svg>

const IconMail= (className,fill) =>
    <svg width={26} height={26} viewBox="0 0 26 26" fill="none" className={className}>
      <g
        clipPath="url(#prefix__clip0)"
        fill={fill}
      >
        <path d="M4.807 9.483a2.5 2.5 0 012.504-2.497l12.994.018A2.5 2.5 0 0122.8 9.508l-.01 6.7a2.5 2.5 0 01-2.503 2.497l-12.994-.018a2.5 2.5 0 01-2.496-2.503l.01-6.701zm2.501-.83a.833.833 0 00-.834.832l-.01 6.7c0 .461.373.835.833.835l12.994.018c.46 0 .834-.372.834-.832l.01-6.7a.833.833 0 00-.833-.835L7.308 8.653z" />
        <path d="M5.484 8.028a.833.833 0 011.16-.208l7.229 5.034 6.99-5.006a.833.833 0 01.97 1.354l-7.468 5.35a.833.833 0 01-.962.007L5.692 9.188a.833.833 0 01-.208-1.16z" />
        <path d="M14.794 12.357a.833.833 0 011.164-.183l6.126 4.468a.833.833 0 01-.982 1.347l-6.126-4.468a.833.833 0 01-.182-1.164zM12.969 12.312a.833.833 0 00-1.164-.186l-6.138 4.451a.833.833 0 10.979 1.35l6.138-4.451a.833.833 0 00.185-1.164z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path
            fill={fill}
            transform="matrix(0 1 1 0 .918 .736)"
            d="M0 0h25v25H0z"
          />
        </clipPath>
      </defs>
    </svg>

const IconMail2= (className,fill) =>
    <svg width={61} height={61} viewBox="0 0 61 61" fill="none" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.62 32.334a6 6 0 012.478-8.116l27.53-14.65a6 6 0 018.115 2.478l7.555 14.197a6 6 0 01-2.478 8.115l-27.53 14.65a6 6 0 01-8.116-2.478L8.62 32.334zm4.357-4.584a2 2 0 00-.826 2.705l7.554 14.196a2 2 0 002.706.826l27.53-14.65a2 2 0 00.826-2.705l-7.555-14.197a2 2 0 00-2.705-.826l-27.53 14.65z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.409 28.487a2 2 0 012.221-1.75l20.993 2.487 9.14-18.502a2 2 0 113.586 1.772l-9.765 19.768a2 2 0 01-2.028 1.1L10.16 30.71a2 2 0 01-1.751-2.222z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.012 27.13a2 2 0 012.259-1.702l18.02 2.534a2 2 0 01-.558 3.961l-18.02-2.534a2 2 0 01-1.701-2.26zM29.097 29.096a2 2 0 00-2.674.924L18.46 46.38a2 2 0 003.597 1.75L30.02 31.77a2 2 0 00-.923-2.674zM5.778 9.095a2 2 0 012-2h19.5a2 2 0 110 4h-19.5a2 2 0 01-2-2zM5.778 16.345a2 2 0 012-2h6.125a2 2 0 010 4H7.778a2 2 0 01-2-2zM6.507 52.845a2 2 0 012-2h6.125a2 2 0 010 4H8.507a2 2 0 01-2-2z"
        fill={fill}
      />
    </svg>

const IconLock= (className,fill) =>
    <svg width={41} height={41} viewBox="0 0 41 41" fill="none" className={className}>
      <path fill="#fff" d="M.41.162v40h40v-40z" />
      <path
        d="M7.863 17.116c0-.736.597-1.333 1.334-1.333H29.78c.736 0 1.333.597 1.333 1.333v17.5c0 .736-.597 1.333-1.333 1.333H9.197a1.333 1.333 0 01-1.334-1.333v-17.5zm2.667 1.333v14.834h17.917V18.449H10.53z"
        fill={fill}
      />
      <path
        d="M19.529 22.533c.736 0 1.333.597 1.333 1.333v4.167a1.333 1.333 0 01-2.667 0v-4.167c0-.736.597-1.333 1.334-1.333zM23.62 6.964c-.817-1.029-2.08-1.847-4.12-1.765-2.093.083-3.404.962-4.238 1.989-.848 1.045-1.227 2.284-1.316 3.08v6.765a1.333 1.333 0 01-2.667 0V10.2c0-.043.002-.085.006-.127.119-1.235.659-3.027 1.907-4.566 1.284-1.582 3.293-2.857 6.2-2.973 2.96-.118 5.016 1.133 6.317 2.772 1.255 1.58 1.784 3.479 1.898 4.776.004.04.006.078.006.118v6.833a1.333 1.333 0 01-2.667 0v-6.77c-.09-.898-.48-2.233-1.326-3.299z"
        fill={fill}
      />
    </svg>

const IconLockEye= (className,fill) =>
    <svg width={40} height={41} viewBox="0 0 40 41" fill="none" className={className}>
      <g clipPath="url(#prefix__clip0)">
        <path fill="#fff" d="M0 .18v40h40v-40z" />
        <path
          d="M7.453 17.135c0-.737.597-1.334 1.333-1.334H29.37c.736 0 1.333.597 1.333 1.334v8.545a1.333 1.333 0 11-2.666 0v-7.212H10.12V33.3h10.59a1.333 1.333 0 110 2.667H8.786a1.333 1.333 0 01-1.333-1.333v-17.5z"
          fill={fill}
        />
        <path
          d="M23.21 6.982c-.817-1.029-2.081-1.847-4.12-1.765-2.093.084-3.404.962-4.238 1.99-.848 1.045-1.228 2.283-1.316 3.08v6.764a1.333 1.333 0 11-2.667 0v-6.833c0-.043.002-.085.006-.127.119-1.235.658-3.027 1.907-4.565 1.284-1.583 3.293-2.857 6.2-2.974 2.96-.118 5.016 1.133 6.317 2.772 1.255 1.581 1.783 3.48 1.898 4.776.004.04.006.079.006.118v6.833a1.333 1.333 0 01-2.667 0v-6.77c-.09-.898-.48-2.233-1.326-3.299zM20.725 31.913c3.622 4.271 6.931 4.927 9.525 4.336 2.563-.584 4.776-2.458 6.202-4.287-1.645-2.102-3.243-3.34-4.713-4.002-1.624-.732-3.172-.8-4.611-.467-2.591.601-4.891 2.53-6.403 4.42zm12.11-6.384c2.176.981 4.315 2.799 6.355 5.642.324.451.334 1.057.025 1.519-1.574 2.352-4.542 5.286-8.373 6.159-4.005.912-8.525-.514-12.858-6.082a1.333 1.333 0 01-.045-1.577c1.658-2.398 4.73-5.4 8.586-6.294 1.967-.456 4.116-.356 6.31.633z"
          fill={fill}
        />
        <path
          d="M28.57 31.355a.513.513 0 100 1.027.513.513 0 000-1.027zm-3.18.514a3.18 3.18 0 116.36 0 3.18 3.18 0 01-6.36 0z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path
            fill="#fff"
            transform="matrix(0 1 1 0 0 .18)"
            d="M0 0h40v40H0z"
          />
        </clipPath>
      </defs>
    </svg>

const IconPhone= (className,fill) =>
  <svg width={21} height={21} viewBox="0 0 21 21" fill="none" className={className}>
    <g clipPath="url(#prefix__clip0)">
      <path
        d="M10.863 17.139a.564.564 0 11-1.127 0 .564.564 0 011.127 0z"
        fill={fill}
      />
      <path
        d="M5.03 15.448c0-.368.298-.666.666-.666h9.206a.667.667 0 010 1.333H5.696a.667.667 0 01-.667-.667z"
        fill={fill}
      />
      <path
        d="M4.766 2.694a2 2 0 012-2h7.068a2 2 0 012 2v15.084a2 2 0 01-2 2H6.766a2 2 0 01-2-2V2.694zm2-.666a.667.667 0 00-.667.666v15.084c0 .368.298.667.667.667h7.068a.667.667 0 00.666-.667V2.694a.667.667 0 00-.666-.666H6.766z"
        fill={fill}
      />
    </g>
  </svg>

const IconPhone2= (className,fill) =>
  <svg width={26} height={26} viewBox="0 0 26 26" fill="none" className={className}>
    <g clipPath="url(#prefix__clip0)" fill={fill}>
      <path d="M18.288 25.736a6.965 6.965 0 01-2.39-.427 25.482 25.482 0 01-9.253-5.898 25.479 25.479 0 01-5.898-9.253A6.915 6.915 0 01.394 6.76 7.078 7.078 0 011.6 3.742a7.107 7.107 0 012.44-2.173A6.961 6.961 0 017.372.736c.368 0 .687.258.764.618l1.226 5.722a.781.781 0 01-.211.716L7.055 9.888A20.564 20.564 0 0016.17 19l2.095-2.095a.781.781 0 01.716-.211l5.723 1.226c.36.077.617.395.617.764 0 1.184-.28 2.305-.832 3.333a7.08 7.08 0 01-5.19 3.644c-.338.05-.675.074-1.01.074zM6.748 2.333a5.411 5.411 0 00-3.87 2.305 5.382 5.382 0 00-.662 4.987 23.696 23.696 0 0014.216 14.216 5.382 5.382 0 004.986-.663 5.411 5.411 0 002.306-3.87l-4.655-.997L16.88 20.5a.781.781 0 01-.884.154A22.12 22.12 0 015.402 10.061a.781.781 0 01.155-.885l2.188-2.188-.997-4.655zM24.538 14.017a.781.781 0 01-.78-.781c0-6.03-4.907-10.937-10.938-10.937a.781.781 0 010-1.563c3.34 0 6.478 1.3 8.839 3.661 2.36 2.361 3.66 5.5 3.66 8.839 0 .431-.349.781-.78.781z" />
      <path d="M21.414 14.017a.781.781 0 01-.782-.781c0-4.308-3.504-7.812-7.812-7.812a.781.781 0 010-1.563c5.17 0 9.375 4.206 9.375 9.375 0 .431-.35.781-.781.781z" />
      <path d="M18.289 14.017a.781.781 0 01-.781-.781 4.693 4.693 0 00-4.688-4.688.781.781 0 010-1.562 6.257 6.257 0 016.25 6.25c0 .431-.35.78-.781.78z" />
    </g>
    <defs>
      <clipPath id="prefix__clip0">
        <path fill="#fff" transform="translate(.32 .736)" d="M0 0h25v25H0z" />
      </clipPath>
    </defs>
  </svg>


const IconCodCli= (className,fill) =>
    <svg width={26} height={26} viewBox="0 0 26 26" fill="none" className={className}>
      <path
        d="M5.271 5.554c0-.46.374-.834.834-.834H19.02c.46 0 .834.374.834.834v15.364c0 .46-.373.834-.834.834H6.105a.833.833 0 01-.834-.834V5.554zm1.667.833v13.698h11.25V6.387H6.938z"
        fill={fill}
      />
      <path
        d="M10.421 13.236a.846.846 0 10-1.692 0 .846.846 0 001.692 0z"
        fill={fill}
      />
      <path
        d="M11.348 13.236c0-.46.373-.833.833-.833h3.382a.833.833 0 110 1.667H12.18a.833.833 0 01-.833-.834z"
        fill={fill}
      />
    </svg>

const IconEye= (className,fill) =>
    <svg width={41} height={41} viewBox="0 0 41 41" fill="none" className={className}>
      <path fill="#fff" d="M.47.18v40h40v-40z" />
      <path
        d="M7.332 20.265c5.91 7.203 11.453 8.455 15.91 7.44 4.419-1.007 8.14-4.318 10.4-7.383-2.73-3.608-5.423-5.749-7.948-6.887-2.68-1.208-5.25-1.323-7.633-.77-4.463 1.034-8.33 4.44-10.729 7.6zm19.458-9.26c3.234 1.457 6.462 4.18 9.577 8.522.324.451.334 1.056.025 1.518-2.387 3.569-6.859 7.962-12.558 9.26-5.872 1.338-12.625-.697-19.229-9.182a1.333 1.333 0 01-.044-1.577c2.52-3.648 7.155-8.148 12.898-9.48 2.91-.674 6.081-.527 9.331.938z"
        fill={fill}
      />
      <path
        d="M20.47 16.597a3.583 3.583 0 100 7.167 3.583 3.583 0 000-7.167zm-6.25 3.583a6.25 6.25 0 1112.5 0 6.25 6.25 0 01-12.5 0z"
        fill={fill}
      />
    </svg>

const IconEyeClose= (className,fill) =>
    <svg width={20} height={21} viewBox="0 0 20 21" fill="none" className={className}>
      <path
        d="M4.248 4.176a.667.667 0 01.943.024l10.042 10.563a.667.667 0 01-.967.918L4.225 5.12a.667.667 0 01.023-.943z"
        fill={fill}
      />
      <path
        d="M8.956 7.234A3.125 3.125 0 0112.9 11.35l-1.108-1.156v-.013c0-.968-.769-1.757-1.729-1.79L8.956 7.234zm-.23 1.687l-.923-.963a3.125 3.125 0 004.324 4.512l-.923-.963a1.792 1.792 0 01-2.479-2.586z"
        fill={fill}
      />
      <path
        d="M11.385 13.943c-2.229.507-5-.119-7.955-3.72.861-1.136 2.102-2.335 3.56-3.111l-.953-.995C4.307 7.12 2.92 8.595 2.044 9.863a.667.667 0 00.022.789c3.302 4.243 6.679 5.26 9.615 4.59a8.624 8.624 0 002.261-.877l-.96-1.002a7.127 7.127 0 01-1.597.58zm-3.08-7.387c.161-.05.324-.095.49-.134 1.19-.276 2.476-.218 3.816.386 1.262.569 2.608 1.64 3.973 3.443a11.032 11.032 0 01-2.432 2.406l.932.972a12.434 12.434 0 002.876-3.016.667.667 0 00-.013-.76c-1.557-2.17-3.171-3.532-4.788-4.26-1.625-.733-3.211-.807-4.666-.47a8.278 8.278 0 00-1.2.378l1.012 1.055z"
        fill={fill}
      />
    </svg>
  
  const IconFolder= (className,fill) =>
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none" className={className}>
      <path
        d="M2.587 8.368a.667.667 0 01.556-.299H15.09c.268 0 .51.16.614.406l3.167 7.437a.667.667 0 01-.613.928H6.311a.667.667 0 01-.614-.406L2.53 8.997a.667.667 0 01.057-.629zm1.565 1.035l2.6 6.103h10.497l-2.6-6.103H4.153z"
        fill={fill}
      />
      <path
        d="M5.078 4.989c0-.368.299-.667.667-.667h5.937c.368 0 .667.299.667.667v.946h5.938c.368 0 .667.298.667.667v9.548a.667.667 0 01-1.333 0V7.268h-5.939a.667.667 0 01-.666-.667v-.945H6.41v2.598a.667.667 0 01-1.333 0V4.99z"
        fill={fill}
      />
    </svg>

  const IconDots= (className,fill) =>
    <svg width={30} height={31} viewBox="0 0 30 31" fill="none" className={className}>
    <path
      d="M16.5 9.025a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM16.5 15.057a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM16.5 21.089a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z"
      fill={fill}
    />
    </svg>

const IconLike= (className,fill) =>
  <svg width={100} height={101} viewBox="0 0 100 101" fill="none" className={className}>
    <path
      d="M58.642 10.556A3.333 3.333 0 0162.386 9.5c6.57 2.383 10.008 6.277 10.904 10.781.83 4.174-.705 8.04-2.267 10.348l-3.78 6.087h10.139c5.99-.047 9.921 2.35 11.899 6.051 1.78 3.334 1.632 7.102 1.062 9.535l-4.778 25.032c-.01.051-.02.102-.033.153-2.224 9.266-8.413 12.71-12.308 12.948a3.364 3.364 0 01-.204.007H45.244c-4.435.092-7.669-1.361-9.618-3.886-1.75-2.268-2.083-4.918-1.877-6.796V42.99c0-.754.256-1.486.726-2.076L58.64 10.556zm3.636 6.136L40.416 44.154v35.81c0 .157-.011.313-.033.468-.08.564.038 1.424.52 2.05.362.467 1.35 1.359 4.228 1.293l.077-.001h27.675c.839-.103 4.575-1.324 6.15-7.77l4.775-25.026a3.36 3.36 0 01.034-.157c.352-1.457.335-3.46-.442-4.914-.599-1.122-1.976-2.56-5.977-2.525H61.25a3.333 3.333 0 01-2.831-5.092l6.979-11.24c.027-.043.055-.086.084-.128.922-1.343 1.65-3.429 1.27-5.341-.27-1.359-1.227-3.244-4.473-4.889z"
      fill={fill}
    />
    <path
      d="M12.084 50.343c0-5.523 4.477-10 10-10h14.945a3.333 3.333 0 013.333 3.334v43.437a3.333 3.333 0 01-3.333 3.333H22.084c-5.523 0-10-4.477-10-10V50.343zm10-3.333a3.333 3.333 0 00-3.333 3.333v30.104a3.333 3.333 0 003.333 3.334h11.612V47.01H22.084z"
      fill={fill}
    />
  </svg>

const IconMoneda= (className,fill) =>
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none" className={className}>
    <path
      d="M10.532 4.151a6.125 6.125 0 100 12.25 6.125 6.125 0 000-12.25zm-7.459 6.125a7.458 7.458 0 1114.917 0 7.458 7.458 0 01-14.917 0z"
      fill={fill}
    />
    <path
      d="M13.496 8.375c.337.149.49.542.341.879l-1.971 4.466a.667.667 0 11-1.22-.54l1.971-4.465a.667.667 0 01.88-.34z"
      fill={fill}
    />
    <path
      d="M9 11.676c-.678 0-1.226-.134-1.643-.402a.557.557 0 01-.298-.504c0-.124.034-.224.102-.298a.318.318 0 01.252-.122c.106 0 .252.05.439.15.199.093.38.165.541.214.168.05.38.075.635.075.261 0 .463-.043.607-.13.149-.088.224-.21.224-.365a.34.34 0 00-.094-.252c-.056-.062-.162-.118-.317-.168a5.499 5.499 0 00-.69-.186c-.555-.112-.953-.271-1.195-.476-.237-.206-.355-.489-.355-.85 0-.273.08-.52.243-.737a1.53 1.53 0 01.662-.513c.286-.125.61-.187.97-.187.262 0 .514.034.757.103.243.062.46.155.653.28.2.124.299.29.299.494 0 .125-.034.23-.103.318a.318.318 0 01-.252.121.598.598 0 01-.205-.037 5.938 5.938 0 01-.243-.131 3.368 3.368 0 00-.466-.205 1.372 1.372 0 00-.486-.075c-.23 0-.414.047-.55.14a.445.445 0 00-.196.383c0 .155.068.273.205.354.137.081.401.162.793.243.417.087.744.187.98.299.237.112.405.252.504.42.106.168.159.382.159.644 0 .423-.177.762-.532 1.017-.348.255-.815.383-1.4.383z"
      fill={fill}
    />
    </svg>

const IconVerified= (className,fill) =>
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none" className={className}>
    <path
      d="M9.976 2.873a.667.667 0 01.509.002l5.52 2.308c.216.09.368.286.403.516.238 1.582.235 4.055-.555 6.385-.797 2.349-2.415 4.602-5.42 5.571a.667.667 0 01-.429-.006c-2.455-.875-6.893-4.482-6.096-11.922a.667.667 0 01.411-.546l5.657-2.308zm-4.779 3.39c-.511 6.249 3.075 9.235 5.045 10.05 2.359-.842 3.667-2.65 4.348-4.657.65-1.915.708-3.968.547-5.39l-4.912-2.054-5.028 2.051z"
      fill={fill}
    />
    <path
      d="M12.966 7.348a.667.667 0 01.031.942L9.65 11.865a.667.667 0 01-.994-.023l-1.312-1.538a.667.667 0 011.014-.866l.828.971 2.84-3.03a.667.667 0 01.941-.03z"
      fill={fill}
    />
    </svg>

const IconHelp= (className,fill) => 
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none" className={className}>
      <path
        d="M11.054 3.708c-3.37 0-6.1 2.742-6.1 6.125s2.73 6.125 6.1 6.125c3.37 0 6.102-2.742 6.102-6.125s-2.732-6.125-6.102-6.125zM3.625 9.833c0-4.12 3.326-7.458 7.43-7.458 4.103 0 7.429 3.339 7.429 7.458 0 4.12-3.326 7.458-7.43 7.458-4.103 0-7.429-3.339-7.429-7.458z"
        fill={fill}
      />
      <path
        d="M11.996 8.071c0 .201-.056.392-.175.576v.001c-.091.144-.273.266-.595.336a3.585 3.585 0 00-.447.113.766.766 0 00-.294.16.564.564 0 00-.138.274 1.59 1.59 0 00-.034.354v1.171c0 .184.05.355.174.485.118.147.294.202.48.202.188 0 .365-.05.492-.183.126-.133.172-.313.172-.504v-.877c.498-.129.908-.363 1.218-.71l.002-.001c.347-.395.514-.894.514-1.48 0-.611-.236-1.123-.7-1.52-.46-.395-1.035-.587-1.708-.587-.54 0-1.04.166-1.499.493-.462.327-.714.754-.714 1.272a.7.7 0 00.177.488l.005.006.006.006a.653.653 0 00.455.177.567.567 0 00.359-.124.62.62 0 00.165-.207c.044-.081.084-.181.12-.295a.715.715 0 01.318-.4h.002c.169-.108.378-.166.636-.166.31 0 .549.09.734.259.18.165.275.384.275.681zm-1.03 4.257c.198 0 .371.072.511.212.147.139.226.314.226.516a.694.694 0 01-.226.517.704.704 0 01-.51.212.704.704 0 01-.513-.214.71.71 0 01-.213-.515.71.71 0 01.213-.514.705.705 0 01.513-.214zm.373.355l.013.014-.013-.014zm-.372-.155a.506.506 0 00-.372.155.51.51 0 010 0 .506.506 0 01.372-.155z"
        fill={fill}
      />
    </svg>

const IconExit= (className,fill) => 
    <svg width={21} height={21} viewBox="0 0 21 21" fill="none" className={className}>
    <path
      d="M6.611 7.528V3.653a2 2 0 012-2h6.167a2 2 0 012 2V16.82a2 2 0 01-2 2H8.611a2 2 0 01-2-2v-3.875h1.334v3.875c0 .368.298.666.666.666h6.167a.667.667 0 00.667-.666V3.653a.667.667 0 00-.667-.667H8.611a.667.667 0 00-.666.667v3.875H6.61z"
      fill={fill}
    />
    <path
      d="M4.861 10.227c0-.368.299-.667.667-.667h6.439a.667.667 0 110 1.334H5.528a.667.667 0 01-.667-.667z"
      fill={fill}
    />
    <path
      d="M9.805 13.726a.667.667 0 01-.087-.939l2.111-2.543-2.112-2.56a.667.667 0 111.028-.849l2.464 2.987a.667.667 0 01-.001.85l-2.464 2.967a.667.667 0 01-.939.087z"
      fill={fill}
    />
    </svg>

const IconTable= (className,fill) => 
    <svg width={25} height={26} viewBox="0 0 25 26" fill="none" className={className}>
    <g
      clipPath="url(#prefix__clip0)"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fill}
    >
      <path d="M.066 1.004C.066.544.44.171.9.171h23.229c.46 0 .833.373.833.833v23.203c0 .46-.373.834-.833.834H.899a.833.833 0 01-.833-.834V1.004zm1.667.834v21.536h21.563V1.838H1.733z" />
      <path d="M4.191 6.735a2.5 2.5 0 012.5-2.5h4.124c.46 0 .833.373.833.833v5.924c0 .46-.373.833-.833.833h-5.79a.833.833 0 01-.834-.833V6.735zm2.5-.834a.833.833 0 00-.833.834v3.423h4.124V5.902h-3.29zM20.84 18.516a2.5 2.5 0 01-2.5 2.5h-4.124a.833.833 0 01-.833-.834v-5.924c0-.46.373-.833.833-.833h5.79c.46 0 .834.373.834.833v4.258zm-2.5.833c.46 0 .833-.373.833-.833v-3.424H15.05v4.257h3.29zM18.406 4.301a2.5 2.5 0 012.5 2.5v4.124c0 .46-.373.833-.833.833h-5.924a.833.833 0 01-.833-.833v-5.79c0-.46.373-.834.833-.834h4.257zm.834 2.5a.833.833 0 00-.834-.833h-3.424v4.123h4.258v-3.29zM6.625 20.949a2.5 2.5 0 01-2.5-2.5v-4.124c0-.46.373-.833.833-.833h5.924c.46 0 .834.373.834.833v5.79c0 .46-.373.834-.834.834H6.625zm-.833-2.5c0 .46.373.833.833.833h3.424v-4.124H5.792v3.29z" />
    </g>
    <defs>
      <clipPath id="prefix__clip0">
        <path
          fill="#fff"
          transform="matrix(0 1 1 0 0 .125)"
          d="M0 0h25v25H0z"
        />
      </clipPath>
    </defs>
    </svg>

const IconFoco = (className) => 
    <svg width={30} height={31} viewBox="0 0 30 31" fill="none" className={className}>
    <rect y={0.652} width={30} height={30} rx={15} fill="#F7C545" />
    <path
      d="M22.525 13.008a.692.692 0 01-.511.206.742.742 0 01-.526-.206.808.808 0 01-.22-.528l-.175-6.062a.778.778 0 01.22-.587.798.798 0 01.584-.25h.234c.224 0 .414.084.57.25a.755.755 0 01.233.587l-.175 6.062a.777.777 0 01-.234.528zm-.467 1.38c.224 0 .418.083.584.25a.806.806 0 01.248.587v.234c0 .225-.082.421-.248.587a.798.798 0 01-.584.25h-.088a.797.797 0 01-.584-.25.805.805 0 01-.249-.587v-.234c0-.226.083-.421.249-.588a.798.798 0 01.584-.25h.088zM12.033 7.866c-2.383.498-4.314 2.41-4.823 4.808-.429 2.024.1 4.057 1.451 5.576a4.108 4.108 0 011.04 2.692v1.055c0 .701.46 1.297 1.093 1.504.208 1.231 1.277 2.222 2.598 2.222 1.32 0 2.39-.99 2.598-2.222a1.585 1.585 0 001.093-1.504v-1.055c0-.971.38-1.94 1.07-2.727a6.314 6.314 0 001.567-4.163c0-3.993-3.654-7.029-7.687-6.186zm1.36 16.802c-.679 0-1.273-.466-1.493-1.093h2.984c-.22.627-.814 1.093-1.492 1.093zm2.636-2.671c0 .29-.237.527-.528.527h-4.218a.528.528 0 01-.527-.527v-.528h5.273v.528zm1.331-4.477c-.735.839-1.187 1.85-1.302 2.895h-5.331a5.211 5.211 0 00-1.277-2.866c-1.127-1.266-1.567-2.963-1.208-4.656.42-1.976 2.03-3.582 4.007-3.995 3.375-.705 6.416 1.83 6.416 5.154a5.26 5.26 0 01-1.305 3.468z"
      fill="#fff"
    />
    </svg>

const IconWarning = (className, fill) => 
    <svg width={30} height={31} viewBox="0 0 30 31" fill="none" className={className}>
    <path 
      d="M15.377 20.11c.328 0 .618.12.851.352.245.231.377.523.377.859 0 .336-.132.628-.377.86a1.178 1.178 0 01-.852.351c-.33 0-.621-.122-.855-.356a1.178 1.178 0 01-.356-.855c0-.33.122-.622.356-.856.234-.234.525-.356.855-.356zm.62.59l.023.023-.023-.022z"
      fill={fill}
    />
    <path
      d="M16.679 17.952a1.257 1.257 0 11-2.514 0v-6.32a1.257 1.257 0 012.514 0v6.32z"
      fill={fill}
    />
    <path 
      d="M15.422 2.205c.402 0 .773.215.974.563l12.805 22.179a1.125 1.125 0 01-.974 1.687H2.617a1.125 1.125 0 01-.975-1.687l12.806-22.18c.2-.347.572-.562.974-.562zM4.565 24.385h21.713L15.423 5.58 4.565 24.384z"
      fill={fill}
    />
    </svg>

const IconCompatible = (className, fill) => 
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" className={className}>
    <circle cx={10} cy={10} r={10} fill={fill} />
    <path 
      d="M10.243 3.232a.4.4 0 01.434.08l1.83 1.756 1.244-1.244a.4.4 0 01.559-.006l1.86 1.774a.4.4 0 01-.002.58l-1.386 1.317 1.895 1.823A.4.4 0 0116.4 10h-6a.4.4 0 01-.4-.4v-6a.4.4 0 01.243-.368zm.557 1.306V9.2h4.607l-1.481-1.424a.4.4 0 01.001-.579l1.386-1.316-1.273-1.215-1.244 1.245a.4.4 0 01-.56.006L10.8 4.538zM9.757 16.768a.4.4 0 01-.434-.08l-1.83-1.756-1.244 1.244a.4.4 0 01-.559.006l-1.86-1.774a.4.4 0 01.002-.58l1.386-1.317-1.895-1.823A.4.4 0 013.6 10h6c.22 0 .4.18.4.4v6a.4.4 0 01-.243.368zM9.2 15.46V10.8H4.593l1.481 1.424a.4.4 0 01-.001.579l-1.386 1.316 1.273 1.215 1.244-1.245a.4.4 0 01.56-.006L9.2 15.461z"
      fill="#F4F6F9"
    />
    </svg>
//Justin ---
const IconBirthday=(className,fill)=>
    <svg width={30} height={30} viewBox="0 0 30 31" fill="none" className={className}>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.599609 29.4405C0.599609 28.9103 1.02942 28.4805 1.55961 28.4805L28.4396 28.4805C28.9698 28.4805 29.3996 28.9103 29.3996 29.4405C29.3996 29.9707 28.9698 30.4005 28.4396 30.4005L1.55961 30.4005C1.02942 30.4005 0.599609 29.9707 0.599609 29.4405Z" fill={fill}/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.6771 15.6991C24.2873 15.3703 23.8023 15.2649 23.5075 15.2698L23.4918 15.27L7.55407 15.2699C6.25229 15.2699 5.56935 15.7253 5.19423 16.1842C4.78659 16.6828 4.65504 17.2953 4.66038 17.6742L4.66057 17.6877L4.66048 29.3437C4.66048 29.8738 4.23067 30.3037 3.70048 30.3037C3.17028 30.3037 2.74048 29.8738 2.74048 29.3437L2.74048 17.6939C2.73159 16.9472 2.96726 15.8748 3.70771 14.969C4.48312 14.0204 5.73491 13.3499 7.55407 13.3499L23.4847 13.3499C24.1568 13.3408 25.1133 13.5552 25.915 14.2314C26.7577 14.9421 27.3271 16.0767 27.3063 17.6941L27.3063 29.3437C27.3063 29.8738 26.8765 30.3037 26.3463 30.3037C25.8161 30.3037 25.3863 29.8738 25.3863 29.3437L25.3863 17.6744C25.4018 16.5551 25.0282 15.9952 24.6771 15.6991Z" fill={fill}/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.60416 17.3672C4.12365 17.2612 4.63072 17.5964 4.73674 18.1159C4.81228 18.4861 5.03802 18.8997 5.3852 19.2549C5.73179 19.6095 6.14514 19.8502 6.5304 19.9384C6.89568 20.022 7.22741 19.9713 7.52621 19.758C7.8439 19.5312 8.23148 19.0427 8.51338 18.0465C8.63217 17.6267 9.01911 17.3397 9.45532 17.348C9.89152 17.3563 10.2673 17.6577 10.3701 18.0817C10.4893 18.5734 10.6662 19.0927 10.9649 19.4635C11.2192 19.7792 11.5783 20.0177 12.2478 19.9672C13.6269 19.8631 14.079 18.7891 14.1208 18.2356C14.1567 17.7607 14.5353 17.3839 15.0103 17.3502C15.4854 17.3166 15.9133 17.6364 16.0157 18.1015C16.2969 19.379 17.1734 19.9645 18.0401 19.9645C18.542 19.9645 19.3743 19.6215 19.7916 18.06C19.9074 17.6267 20.3078 17.3313 20.756 17.3486C21.2041 17.3658 21.5806 17.691 21.6628 18.1319C21.7458 18.5773 22.0283 19.046 22.4525 19.4086C22.8772 19.7714 23.3687 19.9645 23.8001 19.9645C24.3859 19.9645 24.697 19.8415 24.8865 19.6688C25.0802 19.4922 25.3167 19.1085 25.4047 18.2138C25.4566 17.6862 25.9264 17.3005 26.4541 17.3525C26.9817 17.4044 27.3674 17.8742 27.3155 18.4019C27.2035 19.5397 26.864 20.4643 26.1798 21.0879C25.4914 21.7154 24.6224 21.8845 23.8001 21.8845C22.8232 21.8845 21.9041 21.4655 21.2051 20.8681C21.0509 20.7363 20.9038 20.5928 20.7662 20.4389C20.0513 21.3926 19.0743 21.8845 18.0401 21.8845C16.9032 21.8845 15.8653 21.3958 15.1275 20.5398C14.5576 21.2219 13.6816 21.7845 12.3923 21.8818C11.0446 21.9835 10.0892 21.437 9.46968 20.668C9.44662 20.6393 9.42409 20.6105 9.40205 20.5814C9.17543 20.8737 8.92177 21.1208 8.64162 21.3208C7.83737 21.8948 6.92786 21.9991 6.10198 21.81C5.29607 21.6255 4.56833 21.1659 4.01214 20.5969C3.45656 20.0285 3.01785 19.2952 2.85551 18.4998C2.7495 17.9803 3.08468 17.4733 3.60416 17.3672Z" fill={fill}/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.167 9.21289C15.6972 9.21289 16.127 9.6427 16.127 10.1729L16.127 14.2168C16.127 14.747 15.6972 15.1768 15.167 15.1768C14.6368 15.1768 14.207 14.747 14.207 14.2168L14.207 10.1729C14.207 9.6427 14.6368 9.21289 15.167 9.21289Z" fill={fill}/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8075 0.846277C17.095 1.10524 17.1989 1.51152 17.0711 1.87676C16.9335 2.26983 16.9006 2.53567 16.9074 2.73132C16.914 2.9218 16.9599 3.10022 17.057 3.32304C17.142 3.51816 17.2474 3.70928 17.3897 3.96728C17.4289 4.03837 17.471 4.11454 17.5161 4.19727C17.7145 4.56066 17.9417 4.99704 18.1536 5.53997C18.6503 6.81277 18.4439 8.01521 17.729 8.89217C17.0434 9.73316 15.9694 10.1792 14.8805 10.1792C12.8685 10.1792 11.2725 8.23583 11.5662 5.77521C11.7301 4.40212 12.5128 3.26751 13.3277 2.4428C14.1482 1.61255 15.0892 1.00599 15.7551 0.691548C16.105 0.526311 16.5199 0.587315 16.8075 0.846277ZM14.6934 3.79235C14.0354 4.45823 13.5662 5.2187 13.4727 6.00274C13.2864 7.56342 14.2504 8.25924 14.8805 8.25924C15.4705 8.25924 15.9665 8.01547 16.2409 7.67898C16.4859 7.37845 16.6294 6.91575 16.3649 6.23797C16.1962 5.80561 16.0131 5.45105 15.8308 5.11717C15.7986 5.05818 15.7651 4.99753 15.7309 4.93561C15.5827 4.6676 15.4213 4.37561 15.2968 4.08987C15.2078 3.88561 15.13 3.66923 15.0745 3.43533C14.9456 3.54744 14.8177 3.66662 14.6934 3.79235Z" fill={fill}/>
    </svg>

const IconAlert=(className,fill)=>
    <svg width={50} height={30} viewBox="0 0 20 21" fill="none" className={className}>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.251 13.999C10.4701 13.999 10.6633 14.0794 10.8189 14.2338C10.9822 14.3881 11.0702 14.5827 11.0702 14.8067C11.0702 15.0306 10.9822 15.2253 10.8189 15.3796C10.6633 15.534 10.4701 15.6144 10.251 15.6144C10.0307 15.6144 9.83663 15.5331 9.68064 15.3771C9.52464 15.2211 9.44336 15.027 9.44336 14.8067C9.44336 14.5864 9.52464 14.3923 9.68064 14.2363C9.83663 14.0803 10.0307 13.999 10.251 13.999ZM10.6647 14.3931C10.6699 14.398 10.6751 14.403 10.6801 14.408L10.6647 14.3931Z" fill={fill}/>
    <path d="M11.1191 12.5605C11.1191 13.0233 10.744 13.3984 10.2812 13.3984C9.81848 13.3984 9.44334 13.0233 9.44334 12.5605L9.44334 8.34714C9.44334 7.88438 9.81848 7.50924 10.2812 7.50924C10.744 7.50924 11.1191 7.88438 11.1191 8.34714L11.1191 12.5605Z" fill={fill}/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2811 2.0625C10.5491 2.0625 10.7967 2.20545 10.9306 2.4375L19.4674 17.2236C19.6014 17.4557 19.6014 17.7416 19.4674 17.9736C19.3334 18.2057 19.0859 18.3486 18.8179 18.3486L1.74435 18.3486C1.4764 18.3486 1.22881 18.2057 1.09484 17.9736C0.960861 17.7416 0.960861 17.4557 1.09484 17.2236L9.63161 2.4375C9.76558 2.20545 10.0132 2.0625 10.2811 2.0625ZM3.04339 16.8486L17.5189 16.8486L10.2811 4.3125L3.04339 16.8486Z" fill={fill}/>
    </svg>

const IconCamera=(className,fill)=>
<svg width="17" height="15" viewBox="0 0 17 15" fill="none">
<path d="M2.58611 1.93594H4.98611L6.58611 0.335938H11.3861L12.9861 1.93594H15.3861C15.8105 1.93594 16.2174 2.10451 16.5175 2.40457C16.8175 2.70462 16.9861 3.11159 16.9861 3.53594V13.1359C16.9861 13.5603 16.8175 13.9672 16.5175 14.2673C16.2174 14.5674 15.8105 14.7359 15.3861 14.7359H2.58611C2.16177 14.7359 1.7548 14.5674 1.45474 14.2673C1.15469 13.9672 0.986115 13.5603 0.986115 13.1359V3.53594C0.986115 3.11159 1.15469 2.70462 1.45474 2.40457C1.7548 2.10451 2.16177 1.93594 2.58611 1.93594ZM8.98611 4.33594C7.92525 4.33594 6.90783 4.75736 6.15769 5.50751C5.40754 6.25766 4.98611 7.27507 4.98611 8.33594C4.98611 9.3968 5.40754 10.4142 6.15769 11.1644C6.90783 11.9145 7.92525 12.3359 8.98611 12.3359C10.047 12.3359 11.0644 11.9145 11.8145 11.1644C12.5647 10.4142 12.9861 9.3968 12.9861 8.33594C12.9861 7.27507 12.5647 6.25766 11.8145 5.50751C11.0644 4.75736 10.047 4.33594 8.98611 4.33594ZM8.98611 5.93594C9.62263 5.93594 10.2331 6.18879 10.6832 6.63888C11.1333 7.08897 11.3861 7.69942 11.3861 8.33594C11.3861 8.97246 11.1333 9.58291 10.6832 10.033C10.2331 10.4831 9.62263 10.7359 8.98611 10.7359C8.3496 10.7359 7.73915 10.4831 7.28906 10.033C6.83897 9.58291 6.58611 8.97246 6.58611 8.33594C6.58611 7.69942 6.83897 7.08897 7.28906 6.63888C7.73915 6.18879 8.3496 5.93594 8.98611 5.93594Z" fill={fill}/>
</svg>

const IconFoco2=(className,fill)=>
  <svg width={11} height={16} viewBox="0 0 11 16" fill="none" className={className}>
    <path
      d="M4.47.618A5.245 5.245 0 00.453 4.625c-.358 1.687.083 3.38 1.21 4.647.55.619.865 1.436.865 2.243v.88c0 .584.383 1.081.911 1.253.174 1.026 1.065 1.852 2.166 1.852 1.1 0 1.991-.825 2.165-1.852a1.32 1.32 0 00.911-1.254v-.879c0-.809.317-1.616.892-2.272a5.262 5.262 0 001.305-3.47c0-3.327-3.045-5.857-6.406-5.155zM5.605 14.62c-.565 0-1.06-.389-1.243-.911h2.486c-.183.522-.678.911-1.243.911zM7.8 12.394a.44.44 0 01-.44.44H3.847a.44.44 0 01-.44-.44v-.44h4.395v.44zm1.11-3.73c-.613.699-.99 1.542-1.086 2.412H3.382a4.343 4.343 0 00-1.064-2.388c-.939-1.055-1.306-2.47-1.006-3.88a4.374 4.374 0 013.339-3.33C7.464.89 9.998 3.003 9.998 5.773c0 1.064-.386 2.09-1.087 2.89z"
      fill={fill}
    />
  </svg>

const IconHappy=(className,fill)=>
  <svg width={41} height={40} viewBox="0 0 41 40" fill="none" className={className}>
    <g clipPath="url(#prefix__clip0)" fill={fill}>
      <path d="M34.642 5.858A19.87 19.87 0 0020.5 0 19.89 19.89 0 009.182 3.51a.781.781 0 00.886 1.287A18.333 18.333 0 0120.5 1.563c10.166 0 18.438 8.27 18.438 18.437 0 10.166-8.272 18.438-18.438 18.438-10.166 0-18.438-8.272-18.438-18.438 0-3.748 1.119-7.355 3.235-10.432a.78.78 0 10-1.288-.885A19.886 19.886 0 00.5 20a19.87 19.87 0 005.858 14.142A19.87 19.87 0 0020.5 40a19.87 19.87 0 0014.142-5.858A19.87 19.87 0 0040.5 20a19.87 19.87 0 00-5.858-14.142z" />
      <path d="M6.91 7.191a.78.78 0 00.553-1.333.781.781 0 10-.553 1.334zM14.223 25.413a.781.781 0 00-1.509.404 8.072 8.072 0 007.786 5.975 8.072 8.072 0 007.786-5.975.781.781 0 00-1.51-.404A6.507 6.507 0 0120.5 30.23a6.507 6.507 0 01-6.277-4.816zM24.76 19.693a2.064 2.064 0 011.99-1.527c.93 0 1.749.628 1.99 1.527a.781.781 0 001.51-.404 3.627 3.627 0 00-3.5-2.686 3.628 3.628 0 00-3.499 2.686.781.781 0 101.51.404zM14.25 16.604a3.627 3.627 0 00-3.499 2.685.781.781 0 101.509.404 2.064 2.064 0 011.99-1.527c.93 0 1.749.628 1.99 1.527a.782.782 0 001.509-.404 3.627 3.627 0 00-3.5-2.686z" />
    </g>
    <defs>
      <clipPath id="prefix__clip0">
        <path fill="#fff" transform="translate(.5)" d="M0 0h40v40H0z" />
      </clipPath>
    </defs>
  </svg>

const IconLocation=(className,fill)=>
  <svg width="10" height="12" viewBox="0 0 10 12" fill="none" className={className}>
    <path d="M5.2497 0C2.81392 0 0.832031 1.98189 0.832031 4.41792C0.832031 5.05333 0.962086 5.66 1.21839 6.22124C2.32293 8.63824 4.44064 11.1901 5.06353 11.9145C5.11019 11.9687 5.17823 11.9999 5.24983 11.9999C5.32142 11.9999 5.38946 11.9687 5.43613 11.9145C6.05877 11.1902 8.17648 8.63848 9.28139 6.22124C9.53781 5.66 9.66775 5.05333 9.66775 4.41792C9.6675 1.98189 7.68561 0 5.2497 0ZM5.2497 6.7126C3.98441 6.7126 2.9549 5.68309 2.9549 4.41779C2.9549 3.15237 3.98441 2.12287 5.2497 2.12287C6.515 2.12287 7.54451 3.15237 7.54451 4.41779C7.54463 5.68309 6.51512 6.7126 5.2497 6.7126Z" fill={fill}/>
  </svg>

const IconMaleta=(className,fill)=>
  <svg width={13} height={12} viewBox="0 0 13 12" fill="none">
  <g clipPath="url(#prefix__clip0)" fill={fill}>
    <path d="M10.705 6.453c-.766.574-1.701.973-2.72 1.17A1.503 1.503 0 016.5 8.913a1.503 1.503 0 01-1.486-1.29c-1.018-.197-1.953-.596-2.719-1.17C1.137 5.584.5 4.42.5 3.176v6.386c0 .955.777 1.732 1.731 1.732h8.538c.954 0 1.731-.777 1.731-1.732V3.176c0 1.245-.637 2.408-1.795 3.277z" />
    <path d="M5 6.902v-.638c0-.194.157-.352.35-.352h2.3c.193 0 .35.158.35.352v.638c2.193-.475 3.797-1.965 3.797-3.725v-.352H8.97v-.698c0-.783-.637-1.42-1.42-1.42h-2.1c-.783 0-1.42.637-1.42 1.42v.698H1.203v.352c0 1.76 1.604 3.25 3.796 3.725zm-.267-4.775c0-.395.322-.717.717-.717h2.1c.395 0 .717.322.717.717v.698H4.733v-.698z" />
    <path d="M7.298 6.615H5.702v.798a.799.799 0 001.596 0v-.798z" />
  </g>
  <defs>
    <clipPath id="prefix__clip0">
      <path fill="#fff" transform="translate(.5)" d="M0 0h12v12H0z" />
    </clipPath>
  </defs>
  </svg>

const IconPhone3=(className,fill)=>
  <svg width={17} height={17} viewBox="0 0 17 17" fill="none" className={className}>
  <path
    d="M12.483 16.922a4.456 4.456 0 01-1.53-.273 16.307 16.307 0 01-5.922-3.775 16.307 16.307 0 01-3.774-5.922 4.425 4.425 0 01-.226-2.175 4.53 4.53 0 012.332-3.322A4.455 4.455 0 015.497.922a.5.5 0 01.488.395L6.77 4.98a.5.5 0 01-.135.459l-1.341 1.34a13.16 13.16 0 005.833 5.833l1.34-1.34a.5.5 0 01.459-.136l3.662.785a.5.5 0 01.395.489c0 .758-.179 1.475-.532 2.133a4.549 4.549 0 01-3.322 2.332 4.45 4.45 0 01-.646.048zM5.097 1.944c-1 .11-1.887.634-2.476 1.475a3.445 3.445 0 00-.424 3.192 15.165 15.165 0 009.098 9.098 3.445 3.445 0 003.191-.424 3.463 3.463 0 001.476-2.477l-2.98-.638-1.4 1.4a.5.5 0 01-.566.1 14.158 14.158 0 01-6.78-6.78.5.5 0 01.099-.567l1.4-1.4-.638-2.98zM16.483 9.422a.5.5 0 01-.5-.5c0-3.86-3.14-7-7-7a.5.5 0 010-1c2.137 0 4.146.832 5.657 2.343a7.947 7.947 0 012.343 5.657.5.5 0 01-.5.5z"
    fill={fill}
  />
  <path
    d="M14.483 9.422a.5.5 0 01-.5-.5c0-2.757-2.243-5-5-5a.5.5 0 010-1c3.308 0 6 2.691 6 6a.5.5 0 01-.5.5z"
    fill={fill}
  />
  <path
    d="M12.483 9.422a.5.5 0 01-.5-.5c0-1.654-1.346-3-3-3a.5.5 0 010-1c2.206 0 4 1.794 4 4a.5.5 0 01-.5.5z"
    fill={fill}
  />
  </svg>

const IconSupervisor=(className,fill)=>
  <svg width={33} height={32} viewBox="0 0 33 32" fill="none" className={className}>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12.125 5.61a4.294 4.294 0 100 8.588 4.294 4.294 0 000-8.588zM5.697 9.904a6.427 6.427 0 1112.855 0 6.427 6.427 0 01-12.855 0zM3.183 21.134c1.475-2.259 4.082-3.91 8.727-3.91 4.465 0 7.103 1.68 8.695 3.892 1.28 1.776 1.84 3.868 2.226 5.313.072.267.137.512.2.73a1.067 1.067 0 01-1.024 1.364h-19.8a1.067 1.067 0 01-1.036-1.319c.063-.26.125-.566.195-.906.291-1.432.704-3.46 1.817-5.164zm.348 5.256h17.076c-.367-1.323-.82-2.76-1.733-4.028-1.161-1.613-3.132-3.004-6.964-3.004-4.058 0-5.927 1.39-6.94 2.942-.838 1.282-1.155 2.72-1.44 4.09z"
    fill={fill}
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M17.857 4.247a6.427 6.427 0 110 11.314 9.031 9.031 0 001.136-1.814 4.294 4.294 0 100-7.686 9.028 9.028 0 00-1.136-1.814zM19.615 17.256c.348-.02.708-.031 1.081-.031 4.465 0 7.103 1.678 8.696 3.89 1.278 1.777 1.838 3.869 2.225 5.314.072.268.137.512.2.73a1.067 1.067 0 01-1.024 1.364H25.48a15.794 15.794 0 00-.182-2.133h4.095c-.366-1.323-.82-2.76-1.732-4.028-1.015-1.41-2.648-2.65-5.6-2.94a13.384 13.384 0 00-2.445-2.166z"
    fill={fill}
  />
  </svg>

const IconDesktop=(className,fill)=>
  <svg width={25} height={15} viewBox="0 0 25 25" fill="none" className={className}>
  <path
    d="M24.266 3.6H.734A.734.734 0 000 4.334v13.52c0 .405.329.734.734.734h9.177v1.344h-1.98a.734.734 0 000 1.468h9.139a.734.734 0 100-1.468h-1.981v-1.344h9.177a.734.734 0 00.734-.734V4.334a.734.734 0 00-.734-.734zM13.62 19.932h-2.242v-1.344h2.242v1.344zm9.91-2.812H1.469V5.068h22.064V17.12z"
    fill={fill}
  />
  </svg>

const IconKit=(className,fill)=>
  <svg width={20} height={20} viewBox="0 0 34 31" fill="none" className={className}>
    <path
    d="M30 15c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15Z"
    fill={fill}
    />
    <path
    d="M15 18.688a2.19 2.19 0 0 1-2.188-2.188A2.19 2.19 0 0 1 15 14.312a2.19 2.19 0 0 1 2.188 2.188A2.19 2.19 0 0 1 15 18.688Z"
    fill="#fff"
    fillOpacity={0.95}
    />
    <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9 5.5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3.465c0 .02-.016.035-.035.035H24.5a1 1 0 0 1 1 1v3.75H24a.5.5 0 0 0 0 1h1.5V23a1 1 0 0 1-1 1h-19a1 1 0 0 1-1-1v-8.25h2.25a.5.5 0 0 0 0-1H4.5V10a1 1 0 0 1 1-1H9V5.5Zm10.5 3.465c0 .02.016.035.035.035H10.46a.041.041 0 0 0 .041-.041V6.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 .75.75v2.215Zm.144 8.148c.025-.2.044-.4.044-.613a4.87 4.87 0 0 0-.044-.613l1.319-1.03a.315.315 0 0 0 .075-.4l-1.25-2.163a.314.314 0 0 0-.382-.138l-1.556.625a4.569 4.569 0 0 0-1.056-.612l-.238-1.657a.305.305 0 0 0-.306-.262h-2.5a.305.305 0 0 0-.306.262l-.238 1.657a4.805 4.805 0 0 0-1.056.612l-1.556-.625a.305.305 0 0 0-.381.138l-1.25 2.162a.308.308 0 0 0 .075.4l1.318 1.031c-.025.2-.043.407-.043.613 0 .206.018.413.043.613l-1.319 1.03a.315.315 0 0 0-.075.4l1.25 2.163a.314.314 0 0 0 .382.138l1.556-.625c.325.25.675.456 1.056.612l.238 1.657c.018.15.15.262.306.262h2.5a.305.305 0 0 0 .306-.262l.238-1.657a4.802 4.802 0 0 0 1.056-.612l1.556.625c.144.056.306 0 .382-.138l1.25-2.162a.315.315 0 0 0-.076-.4l-1.318-1.031Z"
    fill="#fff"
    fillOpacity={0.95}
    />
  </svg>

const SvgAssets = function (props) {
    const { icon, className = '', fill = '#000' } = props;

    const lib = {
        'icon-logo': IconLogo,
        'curve-top': CurveTop,
        'curve-bottom': CurveBottom,
        'curve-small': CurveSmall,
        'icon-close': IconClose,
        'icon-star': IconStar,
        'icon-home': IconHome,
        'icon-campana': IconCampana,
        'icon-carrito': IconCarrito,
        'icon-menu': IconMenu,
        'icon-chart': IconChart,
        'icon-oferta': IconOferta,
        'icon-arrow-right': IconArrowRight,
        'icon-arrow-left': IconArrowLeft,
        'icon-trofeo': IconTrofeo,
        'icon-list': IconList,
        'icon-list-2': IconList2,
        'icon-list-check': IconListCheck,
        'icon-tag': IconTag,
        'icon-add-cart': IconAddCart,
        'icon-reloj': IconReloj,
        'icon-clip': IconClip,
        'icon-add-file': IconAddFile,
        'icon-trash': IconTrash,
        'icon-trash-2': IconTrash2,
        'icon-refresh': IconRefresh,
        'icon-cart': IconCart,
        'icon-codigo': IconCodigo,
        'icon-moto': IconMoto,
        'icon-lupa': IconLupa,
        'icon-left': IconLeft,
        'icon-right': IconRight,
        'icon-bottom': IconBottom,
        'icon-top': IconTop,
        'icon-download-file': IconDownloadFile,
        'icon-envio': IconEnvio,
        'icon-local': IconLocal,
        'icon-pago': IconPago,
        'icon-edit': IconEdit,
        'icon-check': Iconcheck,
        'icon-info': IconInfo,
        'icon-user': IconUser,
        'icon-mail': IconMail,
        'icon-mail-2': IconMail2,
        'icon-lock': IconLock,
        'icon-lock-eye': IconLockEye,
        'icon-phone': IconPhone,
        'icon-phone-2': IconPhone2,
        'icon-cod-cli': IconCodCli,
        'icon-eye': IconEye,
        'icon-eye-close': IconEyeClose,
        'icon-back': IconBack,
        'icon-folder': IconFolder,
        'icon-dots': IconDots,
        'icon-like': IconLike,
        'icon-moneda': IconMoneda,
        'icon-verified': IconVerified,
        'icon-help': IconHelp,
        'icon-exit': IconExit,
        'icon-table': IconTable,
        'icon-foco': IconFoco,
        'icon-warning': IconWarning,
        'icon-compatible': IconCompatible,
        'icon-birthday' : IconBirthday,
        'icon-alert':IconAlert,
        'icon-camera':IconCamera,
        'icon-foco-2': IconFoco2,
        'icon-happy': IconHappy,
        'icon-location': IconLocation,
        'icon-maleta': IconMaleta,
        'icon-phone-3': IconPhone3,
        'icon-supervisor': IconSupervisor,
        'icon-desktop': IconDesktop,
        'icon-kit': IconKit
    }

    const Element = lib[icon];

    if (!Element) {
        throw new Error(`SvgAssets no encuentra el ícono con el nombre ${icon}. Por favor insertar ícono válido`);
    }

    return Element(className,fill);

};

export { SvgAssets }